<template>
  <div class="grid">
	<template v-if="loader==true">
		<div class="col-12 mb-2 lg:col-12">
			<ProgressBar mode="indeterminate" style="height: .5em" />
		</div>
	</template>
	<div class="col-12 flex flex-column header-landing-seway">
		<div class="indicators-container-7">
			<!-- TOTAL -->
			<div class="kpi-card kpi-total" @click="selectindicador(0)">
				<div class="kpi-header">
					<span class="kpi-label">TOTAL</span>
					<div class="kpi-icon-wrap kpi-icon-total">
						<i class="pi pi-chart-bar"></i>
					</div>
				</div>
				<div class="kpi-value">{{ indicadores_viajes.total_deliveries ?? 0 }}</div>
				<div class="kpi-footer">
					<span class="kpi-badge kpi-badge-neutral">Ver todos</span>
				</div>
			</div>

			<!-- PENDIENTES -->
			<div class="kpi-card kpi-pendiente" @click="selectindicador(1)">
				<div class="kpi-header">
					<span class="kpi-label">PENDIENTES</span>
					<div class="kpi-icon-wrap kpi-icon-pendiente">
						<i class="pi pi-clock"></i>
					</div>
				</div>
				<div class="kpi-value">{{ indicadores_viajes.total_pendiente ?? 0 }}</div>
				<div class="kpi-footer">
					<span class="kpi-badge kpi-badge-pendiente">Filtrar</span>
				</div>
			</div>

			<!-- ACEPTADOS -->
			<div class="kpi-card kpi-aceptado" @click="selectindicador(2)">
				<div class="kpi-header">
					<span class="kpi-label">ACEPTADOS</span>
					<div class="kpi-icon-wrap kpi-icon-aceptado">
						<i class="pi pi-check-circle"></i>
					</div>
				</div>
				<div class="kpi-value">{{ indicadores_viajes.total_aceptado ?? 0 }}</div>
				<div class="kpi-footer">
					<span class="kpi-badge kpi-badge-aceptado">Filtrar</span>
				</div>
			</div>

			<!-- EN TRÁNSITO -->
			<div class="kpi-card kpi-transito" @click="selectindicador(3)">
				<div class="kpi-header">
					<span class="kpi-label">EN TRÁNSITO</span>
					<div class="kpi-icon-wrap kpi-icon-transito">
						<i class="pi pi-send"></i>
					</div>
				</div>
				<div class="kpi-value">{{ indicadores_viajes.total_transito ?? 0 }}</div>
				<div class="kpi-footer">
					<span class="kpi-badge kpi-badge-transito">Filtrar</span>
				</div>
			</div>

			<!-- FINALIZADO -->
			<div class="kpi-card kpi-finalizado" @click="selectindicador(4)">
				<div class="kpi-header">
					<span class="kpi-label">FINALIZADO</span>
					<div class="kpi-icon-wrap kpi-icon-finalizado">
						<i class="pi pi-verified"></i>
					</div>
				</div>
				<div class="kpi-value">
					<i class="pi pi-check kpi-check-icon"></i>
					{{ indicadores_viajes.total_finalizado ?? 0 }}
				</div>
				<div class="kpi-footer">
					<span class="kpi-badge kpi-badge-finalizado">
						Tasa: {{ tasaExito }}%
					</span>
				</div>
			</div>

			<!-- RECHAZADOS -->
			<div class="kpi-card kpi-rechazado" @click="selectindicador(5)">
				<div class="kpi-header">
					<span class="kpi-label">RECHAZADOS</span>
					<div class="kpi-icon-wrap kpi-icon-rechazado">
						<i class="pi pi-times-circle"></i>
					</div>
				</div>
				<div class="kpi-value">{{ indicadores_viajes.total_rechazados ?? 0 }}</div>
				<div class="kpi-footer">
					<span class="kpi-badge kpi-badge-rechazado">Filtrar</span>
				</div>
			</div>

			<!-- ANULADOS -->
			<div class="kpi-card kpi-anulado" @click="selectindicador(6)">
				<div class="kpi-header">
					<span class="kpi-label">ANULADOS</span>
					<div class="kpi-icon-wrap kpi-icon-anulado">
						<i class="pi pi-ban"></i>
					</div>
				</div>
				<div class="kpi-value">{{ indicadores_viajes.total_anulados ?? 0 }}</div>
				<div class="kpi-footer">
					<span class="kpi-badge kpi-badge-anulado">Filtrar</span>
				</div>
			</div>

		</div>
		<div class="last-update">
			Última actualización: {{ fechaFormateada }}
		</div>
	</div>
    <div class="field col-12">
        <!-- {{indicadores_viajes}} -->
        <template v-if="estado_viaje == 10">
			<!-- Header -->
			<div class="dashboard-header-movimientos">
				<h1><i class="pi pi-truck" style="font-size: 2rem"></i> Panel de Control de Viajes</h1>
				<p>Gestione y analice el estado de todos los viajes SEWAY Plus</p>
				<Button 
							label="Crear Viaje" 
							icon="pi pi-plus-circle" 
							class="p-button-rounded p-button-raised button-sewayblue mr-2" 
							@click="openModalNuevoViaje" 
							 :loading="loader"
						/>
			</div>

		</template>
        <template v-else>
			<!-- ── Topbar de estado ── -->
			<div class="sv-topbar">
				<div class="sv-topbar-left">
				<button class="sv-btn-back" @click="estado_viaje = 10; limpiar()">
					<i class="pi pi-arrow-left"></i>
				</button>
				<div>
					<h2 class="sv-title">{{ estado_viaje_descripcion }}</h2>
					<p class="sv-sub">Viajes Seway Plus · {{ pagination.total }} registros</p>
				</div>
				</div>
				<div class="sv-topbar-right">
				<!-- Chips de filtros activos -->
				<div v-if="tieneFiltrosActivos" class="sv-filtros-activos">
					<span class="sv-filtros-label"><i class="pi pi-filter-fill"></i> Filtros:</span>
					<span v-if="frmfiltros.placa" class="sv-chip">
					{{ frmfiltros.placa }}
					<i class="pi pi-times" @click="limpiarFiltro('placa')"></i>
					</span>
					<span v-if="frmfiltros.external_reference" class="sv-chip">
					Ref: {{ frmfiltros.external_reference }}
					<i class="pi pi-times" @click="limpiarFiltro('external_reference')"></i>
					</span>
					<span v-if="frmfiltros.driver_document_id" class="sv-chip">
					CC: {{ frmfiltros.driver_document_id }}
					<i class="pi pi-times" @click="limpiarFiltro('driver_document_id')"></i>
					</span>
					<span v-if="frmfiltros.fechasolicitud && frmfiltros.fechasolicitud.length === 2" class="sv-chip">
					{{ formatFiltroFecha(frmfiltros.fechasolicitud) }}
					<i class="pi pi-times" @click="limpiarFiltro('fechasolicitud')"></i>
					</span>
					<button class="sv-chip-clear" @click="limpiar" title="Limpiar todos">
					<i class="pi pi-times"></i>
					</button>
				</div>
				<button class="sv-btn-outline" @click="toggle">
					<i class="pi pi-filter"></i> Filtrar
				</button>
				<button class="sv-btn-primary" @click="openModalNuevoViaje">
					<i class="pi pi-plus-circle"></i> Crear viaje
				</button>
				</div>
			</div>

			<!-- ── Panel filtros ── -->
			<OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" :style="{width:'560px'}">
				<div class="sv-filtros-panel">
				<div class="sv-filtros-title"><i class="pi pi-filter"></i> Filtros de búsqueda</div>
				<div class="sv-filtros-grid">
					<div class="sv-filtros-field">
					<label>Placa</label>
					<InputMask mask="aaa-999" v-model="frmfiltros.placa" placeholder="ABC-123" />
					</div>
					<div class="sv-filtros-field">
					<label>Referencia externa</label>
					<InputText v-model="frmfiltros.external_reference" type="number" placeholder="Número de referencia" />
					</div>
					<div class="sv-filtros-field">
					<label>Cédula del conductor</label>
					<InputText v-model="frmfiltros.driver_document_id" placeholder="Número de documento" />
					</div>
					<div class="sv-filtros-field">
					<label>Rango de fechas</label>
					<Calendar v-model="frmfiltros.fechasolicitud" selectionMode="range"
						:showButtonBar="true" :showIcon="true"
						:locale="$primevue.config.locale" placeholder="Seleccione fecha inicio – fin" />
					</div>
				</div>
				<div class="sv-filtros-actions">
					<button class="sv-btn-outline" @click="limpiar">
					<i class="pi pi-filter-slash"></i> Limpiar
					</button>
					<button class="sv-btn-primary" @click="cargar_detalle(1)">
					<i class="pi pi-search"></i> Buscar
					</button>
				</div>
				</div>
			</OverlayPanel>

			<!-- ── Tabla ── (el contenido interno DataTable se mantiene igual) -->
			<div class="sv-tabla-outer">
				<div class="p-fluid grid">
				<div class="col-12 lg:col-12">
					<!-- AQUÍ VA EL DataTable existente SIN CAMBIOS -->
					<DataTable :value="deliveries" :expandedRows="expandedRows"
					@rowClick="onRowClick" sortMode="multiple"
					class="tabla-viajes" tableStyle="width: 100%;">
					<Column expander style="width: 2rem" />
					<Column field="delivery_id" header="ID Viaje" sortable>
						<template #body="slotProps">
						<div class="cursor-pointer">
							<strong>{{slotProps.data.delivery_id}}</strong>
						</div>
						</template>
					</Column>
					<Column field="external_reference" header="Referencia Externa" sortable>
						<template #body="slotProps">
						<div class="cursor-pointer">
							<strong>{{slotProps.data.external_reference}}</strong>
						</div>
						</template>
					</Column>
					<Column field="branch_description" header="Sucursal" sortable>
						<template #body="slotProps">
						<div class="cursor-pointer">{{slotProps.data.branch_description}}</div>
						</template>
					</Column>
					<Column field="dispatch_type_description" header="Tipo Operación" sortable>
						<template #body="slotProps">
						<div class="cursor-pointer">{{slotProps.data.dispatch_type_description}}</div>
						</template>
					</Column>
					<Column field="truck_id" header="Placa" sortable>
						<template #body="slotProps">
						<div class="cursor-pointer"><strong>{{slotProps.data.truck_id}}</strong></div>
						</template>
					</Column>
					<Column field="driver_name" header="Conductor" sortable style="width:150px">
						<template #body="slotProps">
						<div class="cursor-pointer">
							{{ toTitleCase(slotProps.data.driver_name) }}<br>
							<span style="font-size:.78rem;color:#6b7280">CC: {{slotProps.data.driver_document_id}}</span>
						</div>
						</template>
					</Column>
					<Column field="created_at" header="Estado" sortable>
						<template #body="slotProps">
						<div class="cursor-pointer">{{slotProps.data.delivery_state}}</div>
						</template>
					</Column>
					<Column field="created_at" header="Fecha Movimiento" sortable>
						<template #body="slotProps">
						<div class="cursor-pointer">{{slotProps.data.created_at}}</div>
						</template>
					</Column>
					<Column field="total_detalle" header="Total Entregas" sortable>
						<template #body="slotProps">
						<div class="cursor-pointer mx-4">
							<h3>{{slotProps.data.delivery_details?.length || 0}}</h3>
						</div>
						</template>
					</Column>
					<Column field="total_entregado" header="Estados Entregas">
						<template #body="slotProps">
						<div class="cursor-pointer">
							<strong>Pendientes: </strong>{{slotProps.data.total_pendientes}}<br>
							<strong>Finalizadas: </strong>{{slotProps.data.total_finalizados}}
						</div>
						</template>
					</Column>
					<template v-if="options">
						<template v-if="options.detalle==1">
						<Column field="anular_viaje" header="Opciones">
							<template #body="slotProps">
							<div class="sv-row-actions">
								<button class="sv-btn-icon sv-btn-icon--warn"
										title="Anular viaje" @click="openanularViaje(slotProps.data)">
								<i class="pi pi-ban"></i>
								</button>
								<button class="sv-btn-icon" title="Duplicar viaje"
										@click="openDuplicarViaje(slotProps.data)">
								<i class="pi pi-clone"></i>
								</button>
							</div>
							</template>
						</Column>
						</template>
					</template>

					<!-- El template #expansion se mantiene EXACTAMENTE igual -->
					<template #expansion="slotProps">
						<!-- CONTENIDO EXISTENTE SIN CAMBIOS -->
						<div class="col-12">
						<div v-if="loader==true" class="col-12 mb-2 lg:col-12">
							<ProgressBar mode="indeterminate" style="height: .5em" />
						</div>
						<div class="col-12 lg:col-12">
							<TabView @tab-click="handleTabChange">
							<template v-if="options">
								<template v-if="options.detalle==1">
								<TabPanel header="Detalles">
									<div class="detalle-container-premium">
									<ProgressBar v-if="loader" mode="indeterminate" style="height: 3px;" />
									<Accordion :multiple="true" class="detalles-accordion-premium">
										<AccordionTab
										v-for="(detalle_mov, index) in slotProps.data.delivery_details"
										:key="index">
										<template #header>
											<div class="accordion-header-premium">
											<div class="header-icon"><i class="pi pi-map-marker"></i></div>
											<div class="header-content">
												<h3 class="detalle-title">Detalle {{ index + 1 }}: {{ toTitleCase(detalle_mov.client_name) }}</h3>
												<div class="detalle-subtitle">
												<span>{{ toTitleCase(detalle_mov.sender_city)+'('+toTitleCase(detalle_mov.sender_country)+')' }} → {{ toTitleCase(detalle_mov.receiver_city)+'('+toTitleCase(detalle_mov.receiver_country)+')' }}</span>
												</div>
											</div>
											<div class="header-badge">
												<Tag :value="getStatusComment(detalle_mov?.status_id, detalle_mov?.status_comment)" severity="info" />
											</div>
											</div>
										</template>
										<!-- EL CONTENIDO DE CADA ACCORDION TAB SE MANTIENE IGUAL -->
										<TabView class="detalle-tabs-premium">
											<TabPanel header="Detalles">
											<div class="cliente-header-premium">
												<div class="cliente-titulo">
												<span class="label">CLIENTE SOLICITANTE</span>
												<strong class="cliente-nombre">{{ toTitleCase(detalle_mov.client_name) }}</strong>
												</div>
												<div class="cliente-info">
												<div>
													<span class="info-label">Ubicación</span>
													<span class="info-value">{{ toTitleCase(detalle_mov.client_city) }}, {{ toTitleCase(detalle_mov.client_department) }}<template v-if="detalle_mov.client_country"> — {{ toTitleCase(detalle_mov.client_country) }}</template></span>
												</div>
												<div v-if="detalle_mov.client_address">
													<span class="info-label">Dirección</span>
													<span class="info-value">{{ toTitleCase(detalle_mov.client_address) }}</span>
												</div>
												<div><span class="info-label">Email</span><span class="info-value">{{ detalle_mov.client_email }}</span></div>
												<div><span class="info-label">Teléfono</span><span class="info-value">{{ detalle_mov.client_phone }}</span></div>
												<div v-if="detalle_mov.client_mobile"><span class="info-label">Celular</span><span class="info-value">{{ detalle_mov.client_mobile }}</span></div>
												</div>
											</div>
											<div class="detalle-content-grid">
												<Card class="info-card-premium producto">
												<template #title><div class="card-title-premium"><i class="pi pi-box"></i><span>PRODUCTO</span></div></template>
												<template #content><div class="info-row"><strong>{{ toTitleCase(detalle_mov.product) }}</strong></div></template>
												</Card>
												<Card class="info-card-premium peso">
												<template #title><div class="card-title-premium"><i class="pi pi-chart-bar"></i><span>PESO</span></div></template>
												<template #content><div class="metric-display"><div class="metric-value">{{ new Intl.NumberFormat().format(detalle_mov.weight) }}</div><div class="metric-unit">kg</div></div></template>
												</Card>
												<Card class="info-card-premium unidades">
												<template #title><div class="card-title-premium"><i class="pi pi-list"></i><span>UNIDADES</span></div></template>
												<template #content><div class="metric-display"><div class="metric-value">{{ detalle_mov.unit }}</div><div class="metric-unit">unidades</div></div></template>
												</Card>
												<Card class="info-card-premium empaque">
												<template #title><div class="card-title-premium"><i class="pi pi-tag"></i><span>EMPAQUE</span></div></template>
												<template #content><div class="info-row"><strong>{{ toTitleCase(detalle_mov.packing) }}</strong></div></template>
												</Card>
											</div>
											<div class="route-visual-premium remitente-destinatario">
												<div class="route-point sender">
												<div class="point-marker"><i class="pi pi-user"></i></div>
												<div class="point-content">
													<div class="point-label">REMITENTE</div>
													<div class="point-name">{{ toTitleCase(detalle_mov.sender_name) }}</div>
													<div class="point-address">{{ toTitleCase(detalle_mov.sender_address) }}<br>{{ toTitleCase(detalle_mov.sender_city) }} ({{ toTitleCase(detalle_mov.sender_country) }})</div>
													<div class="point-extra">
													<div><strong>Tel:</strong> {{ detalle_mov.sender_phone }}</div>
													<div v-if="detalle_mov.sender_email"><strong>Email:</strong> {{ detalle_mov.sender_email }}</div>
													<div v-if="detalle_mov.estimated_pickup"><strong>Recogida:</strong> {{ detalle_mov.estimated_pickup }}</div>
													</div>
												</div>
												</div>
												<div class="route-line"><i class="pi pi-angle-double-right"></i></div>
												<div class="route-point receiver">
												<div class="point-marker"><i class="pi pi-building"></i></div>
												<div class="point-content">
													<div class="point-label">DESTINATARIO</div>
													<div class="point-name">{{ toTitleCase(detalle_mov.receiver_name) }}</div>
													<div class="point-address">{{ toTitleCase(detalle_mov.receiver_address) }}<br>{{ toTitleCase(detalle_mov.receiver_city) }} ({{ toTitleCase(detalle_mov.receiver_country) }})</div>
													<div class="point-extra">
													<div><strong>Tel:</strong> {{ detalle_mov.receiver_phone }}</div>
													<div v-if="detalle_mov.receiver_email"><strong>Email:</strong> {{ detalle_mov.receiver_email }}</div>
													<div v-if="detalle_mov.estimated_delivery"><strong>Entrega:</strong> {{ detalle_mov.estimated_delivery }}</div>
													</div>
												</div>
												</div>
											</div>
											<!-- <div class="map-toggle-premium">
												<Button :label="showMap ? 'Ocultar Mapa' : 'Ver Mapa de Ruta'"
												:icon="showMap ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
												class="p-button-outlined" @click="toggleMap(detalle_mov)" />
											</div>
											<div v-show="showMap" class="map-container-premium">
												<div id="map-detalle" style="width:100%; height:450px; border-radius:8px;"></div>
											</div> -->
											</TabPanel>
											<TabPanel>
											<template #header>Eventos Logísticos ({{ detalle_mov.events?.length || 0 }})</template>
											<div class="flex">
												<div class="timeline-horizontal-premium">
												<div class="timeline-track">
													<div v-for="(evento, eventIndex) in ordenarEventos(detalle_mov.events)" :key="eventIndex"
													class="timeline-event" :class="getEventoClass(evento.event_type_id)">
													<div class="event-circle"><i :class="getEventoIcon(evento.event_type_id)"></i></div>
													<div class="event-card-premium">
														<div class="event-title">{{ evento.event_description }}</div>
														<div class="event-date">{{ evento.event_datetime ? formatDate(evento.event_datetime) : '' }}</div>
														<div class="event-actions-premium">
														<Button v-if="evento.latitude && evento.longitude" label="VER EN MAPA" icon="pi pi-map-marker" class="p-button-sm p-button-outlined" @click="openMapModal(evento, detalle_mov)" />
														<Button v-if="evento.event_images && evento.event_images.length > 0" :label="`VER IMÁGENES (${evento.event_images.length})`" icon="pi pi-image" class="p-button-sm p-button-outlined p-button-warning" :loading="loader" @click="openGaleriaEventos(evento.event_images)" />
														<Button v-if="evento.comment" label="VER COMENTARIO" icon="pi pi-comment" class="p-button-sm p-button-outlined" @click="openModalComment($event, evento.comment, index)" />
														<OverlayPanel ref="eventocomment" appendTo="body" :showCloseIcon="true">
															<div class="grid p-fluid"><div class="col-12 lg:col-12"><p>{{ comentario_evento }}</p></div></div>
														</OverlayPanel>
														<Button v-if="evento.novelty_description" label="VER NOVEDAD" icon="pi pi-comment" class="p-button-sm p-button-outlined" @click="openModalNovedad($event, evento.novelty_description, index)" />
														<OverlayPanel ref="eventonovedad" appendTo="body" :showCloseIcon="true">
															<div class="grid p-fluid"><div class="col-12 lg:col-12"><p>{{ novedad_evento }}</p></div></div>
														</OverlayPanel>
														<Galleria :value="img_eventos" :responsiveOptions="galleriaResponsiveOptions" :numVisible="3" containerStyle="max-width:50%" :circular="true" :fullScreen="true" :showItemNavigators="true" v-model:visible="show_galeria_evnets">
															<template #item="slotProps"><img :src="slotProps.item.blob" :alt="slotProps.item.original_url" style="width:60%;display:block;" /></template>
														</Galleria>
														</div>
													</div>
													<div class="event-connector" v-if="eventIndex < ordenarEventos(detalle_mov.events).length - 1"></div>
													</div>
												</div>
												<div class="timeline-controls">
													<Button icon="pi pi-chevron-left" class="p-button-rounded p-button-text" @click="scrollTimeline('left')" />
													<Button icon="pi pi-chevron-right" class="p-button-rounded p-button-text" @click="scrollTimeline('right')" />
												</div>
												<div class="ver-todos-eventos-btn" v-if="detalle_mov.events && detalle_mov.events.length > 0">
													<Button label="Ver todos los eventos en mapa" icon="pi pi-map" class="p-button-outlined p-button-sm" style="border-color:#EB7D10;color:#EB7D10;" @click="openMapaTodosEventos(detalle_mov)" />
												</div>
												</div>
											</div>
											</TabPanel>
										</TabView>
										</AccordionTab>
									</Accordion>
									</div>
								</TabPanel>
								</template>
								<template v-if="options.preoperacional==1">
								<TabPanel header="Resultado PESV">
									<InspeccionVehicular :inspeccion_vehicular="inspeccion_vehicular" :fecha_inspeccion="fecha_inspeccion" :num_movimiento="deliverie.external_reference" :id_deliverie="deliverie.delivery_id" :datos_vehiculo="[]" :loader="loader" :IdCustomer="id_customer" />
								</TabPanel>
								</template>
								<template v-if="options.actores==1">
								<TabPanel header="Actores">
									<div class="actores-container">
									<div class="actor-card vehiculo">
										<div class="actor-card-header">
										<div class="actor-icon-wrapper vehiculo-icon"><i class="pi pi-car"></i></div>
										<div><div class="actor-tipo">VEHÍCULO</div><div class="actor-nombre">{{ deliverie.truck_id }}</div></div>
										</div>
										<div class="actor-badge-row"><span class="actor-badge placa">🚛 Placa: {{ deliverie.truck_id }}</span></div>
									</div>
									<div class="actor-card conductor">
										<div class="actor-card-header">
										<div class="actor-icon-wrapper conductor-icon"><i class="pi pi-user"></i></div>
										<div><div class="actor-tipo">CONDUCTOR</div><div class="actor-nombre">{{ deliverie.driver_name }}</div></div>
										</div>
										<div class="actor-info-grid">
										<div class="actor-info-item"><span class="actor-info-label">Documento</span><span class="actor-info-value">{{ deliverie.driver_document_id }}</span></div>
										<div class="actor-info-item"><span class="actor-info-label">Email</span><span class="actor-info-value">{{ deliverie.driver_email }}</span></div>
										</div>
									</div>
									<div class="actor-card propietario">
										<div class="actor-card-header">
										<div class="actor-icon-wrapper propietario-icon"><i class="pi pi-briefcase"></i></div>
										<div><div class="actor-tipo">PROPIETARIO</div><div class="actor-nombre">{{ deliverie.owner }}</div></div>
										</div>
										<div class="actor-info-grid">
										<div class="actor-info-item"><span class="actor-info-label">Documento</span><span class="actor-info-value">{{ deliverie.owner_id }}</span></div>
										</div>
									</div>
									<div class="actor-card representante">
										<div class="actor-card-header">
										<div class="actor-icon-wrapper representante-icon"><i class="pi pi-id-card"></i></div>
										<div><div class="actor-tipo">REPRESENTANTE LEGAL</div><div class="actor-nombre">{{ deliverie.representative }}</div></div>
										</div>
										<div class="actor-info-grid">
										<div class="actor-info-item"><span class="actor-info-label">Documento</span><span class="actor-info-value">{{ deliverie.representative_id }}</span></div>
										</div>
									</div>
									</div>
								</TabPanel>
								</template>
							</template>
							</TabView>
						</div>
						</div>
					</template>
					</DataTable>

					<div>
					<Paginator :v-model:first="pagination.from" :rows="pagination.per_page"
						:rowsPerPageOptions="[15]" :totalRecords="pagination.total"
						@page="onChangePage($event)" />
					</div>
				</div>
				</div>
			</div>
		</template>
	</div>
	<Dialog 
		v-model:visible="modal_crear_viaje" 
		:style="{width: '80vw'}"
		:header="titulo_modal" 
		:modal="true" 
		class="p-fluid modal-crear-viaje"
	>
		<TabView>
			<!-- TAB 1: FORMULARIO MANUAL -->
			<TabPanel>
				<template #header>
					<span class="flex align-items-center gap-2">
						<i class="pi pi-file mr-1"></i>
						<span class="font-semibold">Formulario Manual</span>
					</span>
				</template>

				<ModalCrearViaje3Pasos
					ref="wizard"
					:tipos_despachos="tipos_despachos"
					:divipola="divipola"
					:catalogo_marcas="catalogo_marcas"
					:catalogo_configuracion="catalogo_configuracion"
					:loader="loader"
					:mapbox_token="mapbox_token"
					@viaje-guardado="guardarViaje"
					/>
			</TabPanel>	
			<!-- TAB 2: IMPORTAR EXCEL -->
			<TabPanel>
				<template #header>
					<span class="flex align-items-center gap-2">
						<i class="pi pi-upload mr-1"></i>
						<span class="font-semibold">Importar Excel</span>
					</span>
				</template>
				
				<div class="grid p-fluid">
					<!-- Header de importación -->
					<div class="col-12">
						<div class="import-header">
							<div class="import-icon">
								<i class="pi pi-cloud-upload"></i>
							</div>
							<h3>Importar Viajes desde Excel</h3>
							<p>Descargue la plantilla, complete la información en las dos pestañas (Información General y Detalles) y cargue el archivo para crear viajes masivamente.</p>
						</div>
					</div>

					<!-- Botón de descarga de plantilla -->
					<div class="col-12">
						<div class="download-template-card">
							<div class="template-icon">
								<i class="pi pi-file-excel"></i>
							</div>
							<div class="template-info">
								<h4>Plantilla de Excel</h4>
								<p>Descargue la plantilla oficial para importar viajes</p>
								<Button 
									label="Descargar Plantilla Excel" 
									icon="pi pi-download" 
									class="p-button-success"
									@click="descargarPlantilla"
								/>
							</div>
							
						</div>
						
					</div>

					<!-- Área de carga de archivo -->
					<div class="col-12">
						<div class="upload-area" :class="{'drag-over': isDragging}">
							<i class="pi pi-cloud-upload upload-icon"></i>
							<h4>Seleccione un archivo Excel o CSV</h4>
							<p>Arrastre y suelte su archivo aquí o haga clic para seleccionar</p>
							<FileUpload 
								mode="basic" 
								accept=".xlsx,.xls,.csv"
								:maxFileSize="10000000"
								chooseLabel="Seleccionar Archivo"
								class="mt-3"
								@select="onFileSelect"
							/>
							<small class="text-500 mt-2">Formatos aceptados: .xlsx, .xls, .csv (máximo 10MB)</small>
						</div>
					</div>

					<!-- Información del archivo seleccionado -->
					<div class="col-12" v-if="archivoSeleccionado">
						<div class="file-info-card">
							<i class="pi pi-file text-4xl text-primary"></i>
							<div class="file-details">
								<h4>{{archivoSeleccionado.name}}</h4>
								<p>Tamaño: {{formatFileSize(archivoSeleccionado.size)}}</p>
							</div>
							<Button 
								icon="pi pi-times" 
								class="p-button-rounded p-button-danger p-button-text"
								@click="eliminarArchivo"
							/>
						</div>
					</div>

					<!-- Instrucciones importantes -->
					<div class="col-12">
						<div class="instructions-card">
							<div class="instruction-header">
								<i class="pi pi-info-circle mr-2"></i>
								<span>Instrucciones Importantes:</span>
							</div>
							<ul class="instruction-list">
								<li>La plantilla contiene dos pestañas: <strong>"Información General"</strong> y <strong>"Detalles"</strong></li>
								<li>Complete una fila en "Información General" con los datos del viaje</li>
								<li>Complete tantas filas como detalles tenga el viaje en la pestaña "Detalles"</li>
								<li>Los campos marcados con asterisco (*) en la plantilla son obligatorios</li>
								<li>Respete los formatos de fecha (YYYY-MM-DD HH:mm:ss) y números</li>
								<li>Para ciudades use los códigos de la maestra DIVIPOLA</li>
								<li>El sistema validará la estructura antes de importar</li>
							</ul>
						</div>
					</div>
				</div>
			</TabPanel>
		</TabView>

		<template #footer>
			<div class="flex justify-content-between align-items-center w-full">
				<div class="text-sm text-500">
					<i class="pi pi-info-circle mr-1"></i>
					Los campos marcados con * son obligatorios
				</div>
				<div class="flex gap-2">
					<Button 
						label="Cancelar" 
						icon="pi pi-times" 
						:loading="loader" 
						class="button-sewayblue" 
						@click="cerrarModal"
					/>
					<Button label="Guardar Viaje" icon="pi pi-save" class="button-sewayblue"
  						:loading="loader" @click="$refs.wizard.guardarViaje()" />
				</div>
			</div>
		</template>
	</Dialog>
	<!-- Modal Mapa Evento -->
	<Dialog 
		v-model:visible="modal_mapa_evento" 
		:style="{width: '900px'}" 
		header="Ubicación del Evento" 
		:modal="true"
		@hide="destruirMapaEvento"
	>
		<div id="map-evento" style="width:100%; height:500px; border-radius:8px;"></div>
	</Dialog>
	<!-- Modal Mapa Todos los Eventos -->
	<Dialog 
		v-model:visible="modal_mapa_todos_eventos" 
		:style="{width: '900px'}" 
		header="Todos los Eventos en Mapa" 
		:modal="true"
		@hide="destruirMapaTodosEventos"
	>
		<div id="map-todos-eventos" style="width:100%; height:500px; border-radius:8px;"></div>
		
		<!-- Leyenda -->
		<div class="mapa-leyenda">
			<span class="leyenda-item">
				<span class="leyenda-dot" style="background:#1B8A4C;">R</span> Remitente
			</span>
			<span class="leyenda-item">
				<span class="leyenda-dot" style="background:#E53935;">D</span> Destinatario
			</span>
			<span class="leyenda-item">
				<span class="leyenda-dot" style="background:#EB7D10;">1</span> Eventos
			</span>
		</div>
	</Dialog>
	<!-- ══ MODAL ANULAR VIAJE ══ -->
	<Dialog v-model:visible="modalAnular" :style="{width:'440px'}"
			header="Anular viaje" :modal="true" class="sv-dialog">
		<div class="sv-modal-body">
			<div class="sv-confirm-body">
			<div class="sv-confirm-icon sv-confirm-icon--danger">
				<i class="pi pi-ban"></i>
			</div>
			<div>
				<p class="sv-confirm-q">¿Anular este viaje?</p>
				<p class="sv-confirm-sub">
				Esta acción anula el viaje y todas sus entregas asociadas.
				No se puede deshacer.
				</p>
			</div>
			</div>
			<div class="sv-form-field" style="margin-top:.5rem">
			<label>Motivo de anulación <span style="color:#ef4444">*</span></label>
			<Dropdown v-model="frmAnular.motivo_anulacion"
				:options="motivos_anulacion" optionLabel="descripcion" optionValue="descripcion"
				placeholder="Seleccione un motivo"
				:class="{'p-invalid': submitted && !frmAnular.motivo_anulacion}" />
			<span class="sv-error" v-if="submitted && !frmAnular.motivo_anulacion">
				El motivo es obligatorio
			</span>
			<span class="sv-error" v-if="!loader && motivos_anulacion.length === 0">
				No hay motivos configurados, créalos en Configuraciones &gt; Mobile &gt; Motivos Anulación
			</span>
			</div>
			<ProgressBar v-if="loader" mode="indeterminate" style="height:3px;margin-top:.75rem" />
		</div>
		<template #footer>
			<button class="sv-btn-outline" @click="modalAnular = false">
			<i class="pi pi-times"></i> Cancelar
			</button>
			<button class="sv-btn-danger"
					:disabled="!frmAnular.motivo_anulacion || loader"
					@click="anularViaje">
			<i class="pi pi-ban"></i> Anular viaje
			</button>
		</template>
	</Dialog>
  </div>
</template>

<script>
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
// import mapboxgl from 'mapbox-gl';
// import 'mapbox-gl/dist/mapbox-gl.css';
import InspeccionVehicular from './components/InspeccionVehicular.vue'
import ModalCrearViaje3Pasos from './components/ModalCrearViaje3Pasos.vue'
export default {
	data() {
		return {
			message: [],
			indicadores_viajes: [],
			loader: false,
            estado_viaje: 10,
            deliveries: [],
			options: [],
            deliverie: [],
			estado_viaje_descripcion: '',
			fecha_consulta: '',
			comentario_evento:'',
			novedad_evento:'',
			show_galeria_evnets: false,
			modalAnular: false,
			frmAnular:{
				motivo_anulacion:'',
				driver_email:'',
				external_reference:'',
			},
			motivos_anulacion: [],
			img_eventos: [],
            expandedRows: [],
            pagination: {
				current_page: 0,
				from: 0,
				last_page: 0,
				per_page: 0,
				to: 0,
				total: 0
			},
			frmfiltros: {
                fechasolicitud: null,
                rangofechasolicitud: false,
                fechasolicitudrango: null,
                placa: '',
                external_reference: '',
                driver_document_id: '',
            },
            inspeccion_vehicular: null,
            id_customer: null,
			fecha_inspeccion: null,
			showMap: false,
	  		mapUrl: null,
			items: [
					{label: 'Update', icon: 'pi pi-fw pi-refresh'},
					{label: 'Edit', icon: 'pi pi-fw pi-pencil'}
				],
			modal_crear_viaje: false,
			titulo_modal: '',
			perfiles_disponibles: [],
			tiposIdentificacion: [
				{ label: 'Cédula de Ciudadanía', value: 'CC' },
				{ label: 'Cédula de Extranjería', value: 'CE' },
				{ label: 'Pasaporte', value: 'PP' },
				{ label: 'NIT', value: 'NIT' }
			],
			tipos_despachos: [],
			divipola: [],
			catalogo_marcas: [],
			catalogo_configuracion: [],
			catalogo_clase: [],
			frmUsuario: {
				email: '',
				placa: '',
				tipo_despacho: null,
				reference_document: '',
				valor_viaje: null,
				representative_id: '',
				representative: '',
				owner_id: '',
				owner: '',
				hours_validation: '',
				required_firm: 0,
				required_check: 0
			},
			count: 0,
			// Detalles del viaje
			detalles_viaje: [],
			activeAccordions: [],
			erroresValidacion: {},
			// Importación Excel
			archivoSeleccionado: null,
			mapbox_token: null,
			mapInstance: null,
			isDragging: false,
			selectedProducts: null,
			galleriaResponsiveOptions: [
                {
                    breakpoint: "724px",
                    numVisible: 5,
                },
                {
                    breakpoint: "660px",
                    numVisible: 4,
                },
                {
                    breakpoint: "168px",
                    numVisible: 3,
                },
                {
                    breakpoint: "160px",
                    numVisible: 1,
                },
            ],
			modal_mapa_evento: false,
			mapInstanceEvento: null,
			eventoSeleccionado: null,
			detalleMovSeleccionado: null,
			modal_mapa_todos_eventos: false,
			mapInstanceTodosEventos: null,
		}
	},
  	mounted(){
		this.cargarindicadorescustomer();
	},
	watch: {
		
	},
	methods:{
		cargarindicadorescustomer() {
			this.loader = true;
			this.indicadores_viajes = [];
			this.id_customer = null;
			this.fecha_consulta = '';
			var _that = this;

			window.api.call('get', '/cargar_idicadores_viajes_seway', {}).then(function(response) {
				if (response.status == 200) {
					_that.indicadores_viajes = {
						total_deliveries: response.data.data.total_viajes,
						total_pendiente:  response.data.data.detalle_estados.pendiente,
						total_aceptado:   response.data.data.detalle_estados.aceptado,
						total_transito:   response.data.data.detalle_estados.en_transito,
						total_finalizado: response.data.data.detalle_estados.finalizado,
						total_rechazados: response.data.data.detalle_estados.rechazado,
						total_anulados:   response.data.data.detalle_estados.anulado
					};
					_that.id_customer   = response.data.id_customer;
					_that.fecha_consulta = response.data.data.Fecha_Consulta;
					_that.mapbox_token = response.data.mapbox_token;

					// ── Precarga de listas estáticas ────────────────────────────
					_that.divipola              = response.data.divipola              || [];
					_that.catalogo_marcas       = response.data.marca_vehiculo        || [];
					_that.catalogo_configuracion = response.data.configuracion_vehiculo || [];
					
					_that.loader = false;
					_that.selectindicador(0);
				}
			}).catch(function(err) {
				console.log(err);
				_that.loader = false;
			});
		},
		ordenarEventos(eventos) {
			if (!eventos || !Array.isArray(eventos)) return [];
			return [...eventos].sort((a, b) => a.event_type_id - b.event_type_id);
		},
        selectindicador(indicador){
			switch (indicador) {
				case 1:
						this.estado_viaje = 1;
						this.estado_viaje_descripcion = 'Viajes Pendientes';
					break;
				case 2:
						this.estado_viaje = 2;
						this.estado_viaje_descripcion = 'Viajes Aceptados';
					break;
				case 3:
						this.estado_viaje = 3;
						this.estado_viaje_descripcion = 'Viajes en Transito';
					break;
				case 4:
						this.estado_viaje = 4;
						this.estado_viaje_descripcion = 'Viajes Finalizados';
					break;
				case 5:
						this.estado_viaje = 5;
						this.estado_viaje_descripcion = 'Viajes Rechazados';
					break;
				case 6:
						this.estado_viaje = 6;
						this.estado_viaje_descripcion = 'Viajes Anulados';
					break;
				case 0:
						this.estado_viaje = 0;
						this.estado_viaje_descripcion = 'Viajes Sincronizados';
					break;
				default:
					break;
			}
			this.loader = true;
			this.limpiar();
		},
        toggle(event) {
			this.$refs.op.toggle(event);
		},
		openModalComment(event, comentario, index) {
			this.comentario_evento = comentario;
			this.$refs.eventocomment[index].toggle(event);
		},
		openModalNovedad(event, novedad, index) {
			this.novedad_evento = novedad;
			this.$refs.eventonovedad[index].toggle(event);
		},
        onRowClick(event) {
			const selectedRow = event.data;
            this.deliverie = event.data;
			const rowIndex = this.deliveries.indexOf(selectedRow);
			this.showMap = false;

			if (rowIndex !== -1) {
				if (this.expandedRows.includes(selectedRow)) {
				this.expandedRows.splice(this.expandedRows.indexOf(selectedRow), 1);
				} else {
				this.expandedRows.push(selectedRow);
				}
			}
		},
		openModalNuevoViaje(){
			this.get_type_dispatch();
            this.titulo_modal = 'Crear Viaje';
			this.submitted = false;
			this.frmUsuario = {
				id: 0,
				reference_document: '',
				placa: '',
				tipo_despacho: '',
				valor_viaje: 0,
				representative_id: '',
				representative: '',
				owner_id: '',
				owner: '',
				hours_validation: 24,
				email: ''
			};
		},
		toTitleCase(text) {
			if (!text) return '';
			return text
				.toLowerCase()
				.replace(/\b\w/g, l => l.toUpperCase());
		},
		openanularViaje(data){
			// console.log(data);
			// console.log('Ref Externa: '+data.external_reference);
			// console.log('Conductor: '+data.driver_email);
			this.frmAnular.external_reference = data.external_reference;
			this.frmAnular.driver_email = data.driver_email;
			this.modalAnular = true;
			this.frmAnular.motivo_anulacion = '';
			this.cargarMotivosAnulacion();
		},
		cargarMotivosAnulacion(){
			var _that = this;
			window.api.call('post', '/listar_motivos_anulacion_activos', {}).then(function(response) {
				if(response.status == 200){
					_that.motivos_anulacion = response.data.data;
				}
			}).catch(function (err) {
				console.log(err);
			});
		},
		anularViaje(){
			// console.log(data);
			if (this.frmAnular.motivo_anulacion == '') {
				this.submitted = true;
				this.$toast.add({
					severity: 'error',
					summary: 'Error',
					detail: 'Ingrese motivo de anulación',
					life: 5000
				});
				return
			}
			this.loader = true;
			var _that = this;
			axios.post('/anular_solicitud_viaje', {frmAnular: this.frmAnular}).then(response => {
				if(response.status == 200){
					_that.loader = false;
					_that.modalAnular = false;
					_that.cargarindicadorescustomer();
					_that.$toast.add({
						severity: 'success',
						summary: 'Viaje Anulado',
						detail: `Viaje anulado correctamente`,
						life: 3000
					});
					
				}
			}).catch(function (error) {
				
				console.log(error.response.data.message);
				_that.$toast.add({severity:'error', summary: 'Error', detail:error.response.data.message, life: 5000});
				_that.loader = false;
			});
		},
		cerrarModal() {
			this.modal_crear_viaje = false;
			this.limpiarFormulario();
		},
		openDuplicarViaje(data) {
			this.get_type_dispatch_y_poblar(data);
		},

		get_type_dispatch_y_poblar(dataDuplicar) {
			this.loader = true;
			const cookie = {};
			document.cookie.split(';').forEach(el => {
				const [key, value] = el.split('=');
				cookie[key.trim()] = value;
			});
			const id_rol = cookie['IdRol'];
			var _that = this;

			this.tipos_despachos = [];

			window.api.call('post', '/get_type_dispatch', { id_rol })
				.then(response => {
					if (response.status === 200) {
						_that.tipos_despachos = response.data.data;
						_that.titulo_modal = 'Duplicar Viaje — ' + (dataDuplicar.external_reference ?? '');
						_that.modal_crear_viaje = true;

						// Esperar a que el wizard esté montado en el DOM
						_that.$nextTick(() => {
							if (_that.$refs.wizard) {
								_that.$refs.wizard.poblarDesdeDuplicado(dataDuplicar);
							}
						});
					}
				})
				.catch(error => {
					console.error('Error al obtener tipos de despacho:', error);
					_that.$toast.add({
						severity: 'error',
						summary: 'Error',
						detail: 'No se pudieron cargar los tipos de despacho',
						life: 5000
					});
				})
				.finally(() => {
					_that.loader = false;
				});
		},
		// Limpiar formulario
		limpiarFormulario() {
			this.frmUsuario = {
				email: '',
				placa: '',
				tipo_despacho: null,
				reference_document: '',
				valor_viaje: null,
				representative_id: '',
				representative: '',
				owner_id: '',
				owner: '',
				hours_validation: '',
				required_firm: 0,
				required_check: 0
			};
			this.detalles_viaje = [];
			this.activeAccordions = [];
			this.submitted = false;
			this.archivoSeleccionado = null;
		},
		// Agregar nuevo detalle
		agregarDetalle() {
			const nuevoDetalle = {
				secuencia: this.detalles_viaje.length + 1,
				// Origen/Destino
				ciudad_origen: '',
				departamento_origen: '',
				ciudad_destino: '',
				departamento_destino: '',
				// Producto
				producto: '',
				empaque: '',
				peso: null,
				unidades: null,
				// Cliente
				id_cliente: '',
				nombre_cliente: '',
				client_address: '',
				client_phone: '',
				client_mobile: '',
				client_email: '',
				ciudad_cliente: '',
				departamento_cliente: '',
				// Remitente
				send_code: '',
				send_id: '',
				send_name: '',
				send_address: '',
				send_phone: '',
				send_mobile: '',
				send_email: '',
				send_city: '',
				send_country: '',
				send_latitude: '',
				send_longitude: '',
				// Destinatario
				received_code: '',
				received_id: '',
				received_name: '',
				received_address: '',
				received_phone: '',
				received_mobile: '',
				received_email: '',
				received_city: '',
				received_country: '',
				receive_latitude: '',
				receive_longitude: '',
				// Fechas
				load_estimated: null,
				unload_estimated: null,
				// Documentos
				client_document1: '',
				client_document2: '',
				client_document3: '',
				client_document4: '',
				submitted: false,
				errores: {}
			};
			this.detalles_viaje.push(nuevoDetalle);
			this.activeAccordions.push(this.detalles_viaje.length - 1);
			this.$toast.add({
				severity: 'success',
				summary: 'Detalle agregado',
				detail: `Detalle #${nuevoDetalle.secuencia} agregado correctamente`,
				life: 3000
			});
		},
		// Eliminar detalle
		eliminarDetalle(index) {
			this.detalles_viaje.splice(index, 1);
			
			// Reorganizar secuencias
			this.detalles_viaje.forEach((detalle, idx) => {
				detalle.secuencia = idx + 1;
			});
			
			this.$toast.add({
				severity: 'success',
				summary: 'Detalle eliminado',
				detail: 'El detalle ha sido eliminado correctamente',
				life: 3000
			});
		},

		// Validar detalles
		validarDetalles() {
			let todosValidos = true;
			
			this.detalles_viaje.forEach(detalle => {
				detalle.submitted = true;
				
				const camposRequeridos = [
					'ciudad_origen',
					'departamento_origen',
					'ciudad_destino',
					'departamento_destino',
					'producto',
					'peso',
					'unidades',
					'id_cliente',
					'nombre_cliente',
					'send_id',
					'send_name',
					'send_city',
					'send_country',
					'received_id',
					'received_name',
					'received_city',
					'received_country'
				];
				
				const detalleValido = camposRequeridos.every(campo => {
					return detalle[campo] !== '' && detalle[campo] !== null;
				});
				
				if (!detalleValido) {
					todosValidos = false;
				}
			});
			
			return todosValidos;
		},

		// Validar formulario principal
		validarFormularioPrincipal() {
			this.submitted = true;
			
			const camposRequeridos = [
				'email',
				'placa',
				'tipo_despacho',
				'reference_document',
				'valor_viaje',
				'representative_id',
				'representative',
				'owner_id',
				'owner',
				'hours_validation'
			];
			
			return camposRequeridos.every(campo => {
				return this.frmUsuario[campo] !== '' && this.frmUsuario[campo] !== null;
			});
		},
		get_type_dispatch() {
			this.loader = true;
			const cookie = {};
			document.cookie.split(';').forEach(el => {
				const [key, value] = el.split('=');
				cookie[key.trim()] = value;
			});
			const id_rol = cookie['IdRol'];
			var _that = this;

			this.tipos_despachos = [];
			// ← No se resetean divipola, catalogo_marcas ni catalogo_configuracion
			//   porque ya están precargados desde mounted()

			window.api.call('post', '/get_type_dispatch', { id_rol })
				.then(response => {
					if (response.status === 200) {
						_that.tipos_despachos = response.data.data;
						_that.modal_crear_viaje = true; // ← abre inmediatamente
					}
				})
				.catch(error => {
					console.error('Error al obtener tipos de despacho:', error);
					_that.$toast.add({
						severity: 'error',
						summary: 'Error',
						detail: 'No se pudieron cargar los tipos de despacho',
						life: 5000
					});
				})
				.finally(() => {
					_that.loader = false;
				});
		},
		// Guardar viaje
		// En el componente PADRE — reemplaza el método guardarViaje completo
		guardarViaje(payload) {
			// payload llega desde el emit del wizard: { viaje, detalles }
			// Si no hay payload, fue llamado directamente (no debería pasar)
			if (!payload || !payload.viaje) {
				this.$toast.add({
					severity: 'error',
					summary: 'Error',
					detail: 'No se recibieron datos del formulario',
					life: 5000
				});
				return;
			}

			const IdRol = 'IdRol';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
				let [key, value] = el.split('=');
				cookie[key.trim()] = value;
			});
			const id_rol = cookie[IdRol];
			var _that = this;

			this.loader = true;

			window.api.call('post', '/crear_viaje', {
				viaje: payload.viaje,
				detalles: payload.detalles,
				id_rol: id_rol
			})
			.then(response => {
				if (response.status === 200) {
					_that.$toast.add({
						severity: 'success',
						summary: 'Viaje creado',
						detail: 'El viaje ha sido creado exitosamente',
						life: 3000
					});
					_that.modal_crear_viaje = false;
					_that.$refs.wizard.resetWizard();
					_that.cargar_detalle(1);
				}
			})
			.catch(error => {
				console.error('Error al crear viaje:', error);
				const msg = error?.data?.data?.message;
				if (msg) {
					const mensajes = Array.isArray(msg) ? msg : [msg];
					mensajes.forEach(m => {
						_that.$toast.add({ severity: 'error', summary: 'Error', detail: m, life: 5000 });
					});
				} else {
					_that.$toast.add({
						severity: 'error',
						summary: 'Error',
						detail: 'Ocurrió un error al crear el viaje',
						life: 5000
					});
				}
			})
			.finally(() => {
				_that.loader = false;
			});
		},

		// Manejo de archivos Excel
		onFileSelect(event) {
			this.archivoSeleccionado = event.files[0];
			this.$toast.add({
				severity: 'success',
				summary: 'Archivo seleccionado',
				detail: `${this.archivoSeleccionado.name} cargado correctamente`,
				life: 3000
			});
		},

		eliminarArchivo() {
			this.archivoSeleccionado = null;
			this.$toast.add({
				severity: 'info',
				summary: 'Archivo eliminado',
				detail: 'El archivo ha sido eliminado',
				life: 3000
			});
		},

		formatFileSize(bytes) {
			if (bytes === 0) return '0 Bytes';
			const k = 1024;
			const sizes = ['Bytes', 'KB', 'MB', 'GB'];
			const i = Math.floor(Math.log(bytes) / Math.log(k));
			return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
		},

		descargarPlantilla() {
			// Aquí implementarías la descarga de la plantilla Excel
			this.$toast.add({
				severity: 'info',
				summary: 'Descargando plantilla',
				detail: 'La plantilla se está descargando...',
				life: 3000
			});
		},

		// Manejo de drag & drop
		onDragEnter(event) {
			event.preventDefault();
			this.isDragging = true;
		},

		onDragLeave(event) {
			event.preventDefault();
			this.isDragging = false;
		},

		onDrop(event) {
			event.preventDefault();
			this.isDragging = false;
			
			const files = event.dataTransfer.files;
			if (files.length > 0) {
				const file = files[0];
				const validExtensions = ['.xlsx', '.xls', '.csv'];
				const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
				
				if (validExtensions.includes(fileExtension)) {
					this.archivoSeleccionado = file;
					this.$toast.add({
						severity: 'success',
						summary: 'Archivo cargado',
						detail: `${file.name} cargado correctamente`,
						life: 3000
					});
				} else {
					this.$toast.add({
						severity: 'error',
						summary: 'Formato inválido',
						detail: 'Por favor seleccione un archivo Excel o CSV',
						life: 5000
					});
				}
			}
		},
        limpiar(){
			this.frmfiltros = {
				fechasolicitud: null,
				fechasolicitudrango: null,
				placa: '',
				external_reference: '',
				driver_document_id: ''
			};
			this.cargar_detalle(1);
		},
		openMapaTodosEventos(detalle_mov) {
			this.detalleMovSeleccionado = detalle_mov;
			this.modal_mapa_todos_eventos = true;

			this.$nextTick(() => {
				this.$nextTick(() => {
					this.inicializarMapaTodosEventos(detalle_mov);
				});
			});
		},

		inicializarMapaTodosEventos(detalle_mov) {
			const mapDiv = document.getElementById('map-todos-eventos');
			if (!mapDiv) return;

			if (this.mapInstanceTodosEventos) {
				this.mapInstanceTodosEventos.remove();
				this.mapInstanceTodosEventos = null;
			}

			// Centro inicial en remitente o primer evento
			const origenLat = parseFloat(detalle_mov.sender_latitude);
			const origenLng = parseFloat(detalle_mov.sender_longitude);
			const centerLat = !isNaN(origenLat) ? origenLat : parseFloat(detalle_mov.events?.[0]?.latitude ?? 0);
			const centerLng = !isNaN(origenLng) ? origenLng : parseFloat(detalle_mov.events?.[0]?.longitude ?? 0);

			this.mapInstanceTodosEventos = L.map('map-todos-eventos').setView([centerLat, centerLng], 13);

			L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				maxZoom: 19,
				attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
			}).addTo(this.mapInstanceTodosEventos);

			const boundsPoints = [];

			// ── Marcador REMITENTE ──────────────────────────────────────
			if (!isNaN(origenLat) && !isNaN(origenLng)) {
				const iconoR = L.divIcon({
					className: '',
					html: `<div style="background:#1B8A4C;color:white;border-radius:50%;
							width:32px;height:32px;display:flex;align-items:center;
							justify-content:center;font-weight:bold;font-size:13px;
							border:2px solid white;box-shadow:0 2px 6px rgba(0,0,0,0.4);">R</div>`,
					iconSize: [32, 32], iconAnchor: [16, 16]
				});
				L.marker([origenLat, origenLng], { icon: iconoR })
					.addTo(this.mapInstanceTodosEventos)
					.bindPopup(`<strong>📦 Remitente</strong><br>${detalle_mov.sender_name ?? ''}`);
				boundsPoints.push([origenLat, origenLng]);
			}

			// ── Marcador DESTINATARIO ───────────────────────────────────
			const destinoLat = parseFloat(detalle_mov.received_latitude);
			const destinoLng = parseFloat(detalle_mov.received_longitude);
			if (!isNaN(destinoLat) && !isNaN(destinoLng)) {
				const iconoD = L.divIcon({
					className: '',
					html: `<div style="background:#E53935;color:white;border-radius:50%;
							width:32px;height:32px;display:flex;align-items:center;
							justify-content:center;font-weight:bold;font-size:13px;
							border:2px solid white;box-shadow:0 2px 6px rgba(0,0,0,0.4);">D</div>`,
					iconSize: [32, 32], iconAnchor: [16, 16]
				});
				L.marker([destinoLat, destinoLng], { icon: iconoD })
					.addTo(this.mapInstanceTodosEventos)
					.bindPopup(`<strong>🏁 Destinatario</strong><br>${detalle_mov.receiver_name ?? ''}`);
				boundsPoints.push([destinoLat, destinoLng]);
			}

			// ── Línea remitente → destinatario ──────────────────────────
			if (!isNaN(origenLat) && !isNaN(origenLng) && !isNaN(destinoLat) && !isNaN(destinoLng)) {
				L.polyline(
					[[origenLat, origenLng], [destinoLat, destinoLng]],
					{ color: '#0A354E', weight: 3, opacity: 0.5, dashArray: '8, 6' }
				).addTo(this.mapInstanceTodosEventos);
			}

			// ── Geocercas ───────────────────────────────────────────────
			if (detalle_mov.geofence_send && Object.keys(detalle_mov.geofence_send).length > 0) {
				this._dibujarGeocercaMapbox(this.mapInstanceTodosEventos, detalle_mov.geofence_send, '#1E88E5', detalle_mov.geofence_send.name ?? 'Geocerca Remitente');
			}
			if (detalle_mov.geofence_received && Object.keys(detalle_mov.geofence_received).length > 0) {
				this._dibujarGeocercaMapbox(this.mapInstanceTodosEventos, detalle_mov.geofence_received, '#E53935', 'Geocerca Destinatario');
			}

			// ── Marcadores de TODOS LOS EVENTOS ────────────────────────
			const eventosOrdenados = this.ordenarEventos(detalle_mov.events);
			const eventosConCoordenadas = eventosOrdenados.filter(e => e.latitude && e.longitude);

			eventosConCoordenadas.forEach((evento, idx) => {
				const eLat = parseFloat(evento.latitude);
				const eLng = parseFloat(evento.longitude);
				if (isNaN(eLat) || isNaN(eLng)) return;

				const iconoE = L.divIcon({
					className: '',
					html: `<div style="background:#EB7D10;color:white;border-radius:50%;
							width:30px;height:30px;display:flex;align-items:center;
							justify-content:center;font-weight:bold;font-size:11px;
							border:2px solid white;box-shadow:0 2px 6px rgba(235,125,16,0.5);">${idx + 1}</div>`,
					iconSize: [30, 30], iconAnchor: [15, 15]
				});

				L.marker([eLat, eLng], { icon: iconoE })
					.addTo(this.mapInstanceTodosEventos)
					.bindPopup(`
						<strong>${idx + 1}. ${evento.event_description ?? 'Evento'}</strong><br>
						<small style="color:#64748b;">${evento.event_datetime ? this.formatDate(evento.event_datetime) : ''}</small>
						${evento.comment ? `<br><em style="color:#475569;">${evento.comment}</em>` : ''}
					`);

				boundsPoints.push([eLat, eLng]);
			});

			// ── Línea conectando eventos en orden ───────────────────────
			if (eventosConCoordenadas.length > 1) {
				const rutaEventos = eventosConCoordenadas
					.map(e => [parseFloat(e.latitude), parseFloat(e.longitude)])
					.filter(c => !isNaN(c[0]) && !isNaN(c[1]));

				L.polyline(rutaEventos, {
					color: '#EB7D10',
					weight: 2,
					opacity: 0.6,
					dashArray: '5, 5'
				}).addTo(this.mapInstanceTodosEventos);
			}

			// ── Ajustar bounds ──────────────────────────────────────────
			if (boundsPoints.length > 1) {
				this.mapInstanceTodosEventos.fitBounds(
					L.latLngBounds(boundsPoints),
					{ padding: [50, 50], maxZoom: 14 }
				);
			}

			setTimeout(() => {
				this.mapInstanceTodosEventos.invalidateSize();
			}, 150);
		},

		destruirMapaTodosEventos() {
			if (this.mapInstanceTodosEventos) {
				this.mapInstanceTodosEventos.remove();
				this.mapInstanceTodosEventos = null;
			}
		},
        cargar_detalle(page){
			this.loader = true;
			var _that = this;
			if(this.frmfiltros.placa){
				this.frmfiltros.placa = this.frmfiltros.placa.replaceAll('-', '');
			}
			this.options = [];
			this.deliveries = [];
			this.deliveries_feka = [];
                window.api.call('post', '/cargar_deliveries_seway?&page='+page, {pagina: page,estado_viaje: this.estado_viaje,frmfiltros: this.frmfiltros}).then( function(response) {
                    if(response.status == 200){
						_that.deliveries = response.data.data.data;
						_that.pagination = response.data.data.metadata.pagination;
						_that.options = response.data.options;
						_that.loader = false;
						_that.$refs.op.hide();
							
                    }
                }).catch(function (err) {
                    console.log(err);
					_that.loader = false;
                });
		},
		toggleMap(detalle_mov) {
			this.showMap = !this.showMap;

			if (this.showMap) {
				// Doble nextTick: primero Vue muestra el div, luego Leaflet lo encuentra
				this.$nextTick(() => {
					this.$nextTick(() => {
						this.inicializarMapa(detalle_mov);
					});
				});
			} else {
				this.destruirMapa();
			}
		},

		inicializarMapa(detalle_mov) {
			const mapDiv = document.getElementById('map-detalle');
			if (!mapDiv) return;

			if (this.mapInstance) {
				this.mapInstance.remove();
				this.mapInstance = null;
			}

			const origenLat = parseFloat(detalle_mov.sender_latitude);
			const origenLng = parseFloat(detalle_mov.sender_longitude);
			const destinoLat = parseFloat(detalle_mov.received_latitude);
			const destinoLng = parseFloat(detalle_mov.received_longitude);

			// ── VALIDAR que las coordenadas sean números válidos ──────────
			const origenValido = !isNaN(origenLat) && !isNaN(origenLng);
			const destinoValido = !isNaN(destinoLat) && !isNaN(destinoLng);

			if (!origenValido && !destinoValido) {
				// Sin coordenadas: mostrar mensaje en el div
				mapDiv.innerHTML = `
					<div style="display:flex;align-items:center;justify-content:center;
						height:450px;background:#f8fafb;border-radius:8px;
						border:1px solid #e2e8f0;flex-direction:column;gap:1rem;">
						<i class="pi pi-map" style="font-size:3rem;color:#94a3b8;"></i>
						<p style="color:#64748b;font-size:1rem;margin:0;">
							No hay coordenadas disponibles para este detalle
						</p>
					</div>`;
				return;
			}

			// Centro: usar lo que esté disponible
			let centerLat, centerLng, initialZoom;

			if (origenValido && destinoValido) {
				centerLat = (origenLat + destinoLat) / 2;
				centerLng = (origenLng + destinoLng) / 2;
				initialZoom = 13;
			} else if (origenValido) {
				centerLat = origenLat;
				centerLng = origenLng;
				initialZoom = 15;
			} else {
				centerLat = destinoLat;
				centerLng = destinoLng;
				initialZoom = 15;
			}

			this.mapInstance = L.map('map-detalle').setView([centerLat, centerLng], initialZoom);

			L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				maxZoom: 19,
				attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
			}).addTo(this.mapInstance);

			const iconoRemitente = L.divIcon({
				className: '',
				html: `<div style="background:#1B8A4C;color:white;border-radius:50%;
						width:32px;height:32px;display:flex;align-items:center;
						justify-content:center;font-weight:bold;font-size:13px;
						border:2px solid white;box-shadow:0 2px 6px rgba(0,0,0,0.4);">R</div>`,
				iconSize: [32, 32], iconAnchor: [16, 16]
			});

			const iconoDestinatario = L.divIcon({
				className: '',
				html: `<div style="background:#E53935;color:white;border-radius:50%;
						width:32px;height:32px;display:flex;align-items:center;
						justify-content:center;font-weight:bold;font-size:13px;
						border:2px solid white;box-shadow:0 2px 6px rgba(0,0,0,0.4);">D</div>`,
				iconSize: [32, 32], iconAnchor: [16, 16]
			});

			const boundsPoints = [];

			// Solo agregar marcadores si las coordenadas son válidas
			if (origenValido) {
				L.marker([origenLat, origenLng], { icon: iconoRemitente })
					.addTo(this.mapInstance)
					.bindPopup(`<strong>📦 Remitente</strong><br>${detalle_mov.sender_name ?? ''}<br>Lat: ${origenLat}<br>Lng: ${origenLng}`);
				boundsPoints.push([origenLat, origenLng]);
			}

			if (destinoValido) {
				L.marker([destinoLat, destinoLng], { icon: iconoDestinatario })
					.addTo(this.mapInstance)
					.bindPopup(`<strong>🏁 Destinatario</strong><br>${detalle_mov.receiver_name ?? ''}<br>Lat: ${destinoLat}<br>Lng: ${destinoLng}`);
				boundsPoints.push([destinoLat, destinoLng]);
			}

			// Línea solo si ambos puntos existen
			if (origenValido && destinoValido) {
				L.polyline(
					[[origenLat, origenLng], [destinoLat, destinoLng]],
					{ color: '#0A354E', weight: 3, opacity: 0.7, dashArray: '8, 6' }
				).addTo(this.mapInstance);
			}

			// Geocercas
			if (detalle_mov.geofence_send && Object.keys(detalle_mov.geofence_send).length > 0) {
				this._dibujarGeocercaMapbox(detalle_mov.geofence_send, '#1E88E5', detalle_mov.geofence_send.name ?? 'Geocerca Remitente');
			}
			if (detalle_mov.geofence_received && Object.keys(detalle_mov.geofence_received).length > 0) {
				this._dibujarGeocercaMapbox(detalle_mov.geofence_received, '#E53935', 'Geocerca Destinatario');
			}

			// Ajustar bounds solo si hay puntos válidos
			if (boundsPoints.length > 1) {
				const bounds = L.latLngBounds(boundsPoints);
				this.mapInstance.fitBounds(bounds, { 
					padding: [60, 60],
					maxZoom: 14  // ← evita que haga zoom excesivo hacia afuera
				});
			} else if (boundsPoints.length === 1) {
				this.mapInstance.setView(boundsPoints[0], 15);
			}

			// Incluir también las geocercas en los bounds para que todo sea visible
			setTimeout(() => {
				this.mapInstance.invalidateSize();
				
				// Re-ajustar bounds incluyendo geocercas si existen
				const allLayers = [];
				this.mapInstance.eachLayer(layer => {
					if (layer instanceof L.Circle || layer instanceof L.Polygon || layer instanceof L.Marker) {
						allLayers.push(layer);
					}
				});
				
				if (allLayers.length > 1) {
					const group = L.featureGroup(allLayers);
					this.mapInstance.fitBounds(group.getBounds(), { 
						padding: [40, 40],
						maxZoom: 14
					});
				}
			}, 150);
		},
		destruirMapa() {
			if (this.mapInstance) {
				this.mapInstance.remove();
				this.mapInstance = null;
			}
		},
		// ── Helper: inicializar mapa base ──────────────────────────────────
		_crearMapa(containerId, center, zoom) {
			window.mapboxgl.accessToken = this.mapbox_token;
			const map = new window.mapboxgl.Map({
				container: containerId,
				style: 'mapbox://styles/mapbox/streets-v12',
				center: [center[1], center[0]],
				zoom: zoom ?? 13,
				attributionControl: true,
			});
			map.addControl(new window.mapboxgl.NavigationControl(), 'top-right');
			return map;
		},
		
		// ── Helper: destruir mapa ──────────────────────────────────────────
		_destruirMapa(mapRef) {
			if (mapRef) {
			mapRef.remove();
			}
			return null;
		},
		
		// ── Helper: marcador con div personalizado ─────────────────────────
		_crearMarcador(map, lngLat, html, popupHtml) {
			const el = document.createElement('div');
			el.innerHTML = html;
			el.style.cursor = 'pointer';
			const marker = new window.mapboxgl.Marker({ element: el }).setLngLat(lngLat);
			if (popupHtml) {
				const popup = new window.mapboxgl.Popup({ offset: 20, closeButton: true })
				.setHTML(popupHtml);
				marker.setPopup(popup);
			}
			marker.addTo(map);
			return marker;
		},
		
		// ── Helper: línea entre puntos ─────────────────────────────────────
		_crearLinea(map, coordenadas, color, dasharray, id) {
			// coordenadas: array de [lat, lng] → convertimos a [lng, lat]
			const sourceId = id || ('linea-' + Date.now());
			map.addSource(sourceId, {
			type: 'geojson',
			data: {
				type: 'Feature',
				geometry: {
				type: 'LineString',
				coordinates: coordenadas.map(c => [c[1], c[0]]),
				},
			},
			});
			map.addLayer({
			id: sourceId,
			type: 'line',
			source: sourceId,
			paint: {
				'line-color': color || '#0A354E',
				'line-width': 3,
				'line-opacity': 0.6,
				'line-dasharray': dasharray || [1],
			},
			});
		},
		
		// ── Helper: fitBounds ──────────────────────────────────────────────
		// points: array de [lat, lng]
		_ajustarBounds(map, points, padding) {
			if (!points || points.length < 2) return;
			let minLng = Infinity, maxLng = -Infinity;
			let minLat = Infinity, maxLat = -Infinity;
			points.forEach(([lat, lng]) => {
			if (lng < minLng) minLng = lng;
			if (lng > maxLng) maxLng = lng;
			if (lat < minLat) minLat = lat;
			if (lat > maxLat) maxLat = lat;
			});
			map.fitBounds(
			[[minLng, minLat], [maxLng, maxLat]],
			{ padding: padding ?? 60, maxZoom: 14, duration: 800 }
			);
		},
		
		// ── Helper: geocerca circular ──────────────────────────────────────
		_geocercaCircular(map, geofence, color, titulo, idPrefix) {
			if (!geofence?.center || geofence.center.lat === undefined) return;
			const cLat = parseFloat(geofence.center.lat);
			const cLng = parseFloat(geofence.center.lng);
			if (isNaN(cLat) || isNaN(cLng)) return;
			const radioM = parseFloat(geofence.radius);
			if (isNaN(radioM) || radioM <= 0) return;
		
			// Generar polígono circular (64 puntos)
			const puntos = [];
			for (let i = 0; i <= 64; i++) {
			const angulo = (i * 360) / 64;
			const rad = (angulo * Math.PI) / 180;
			// Aproximación en grados para radio en metros
			const dLat = (radioM / 111320) * Math.cos(rad);
			const dLng = (radioM / (111320 * Math.cos((cLat * Math.PI) / 180))) * Math.sin(rad);
			puntos.push([cLng + dLng, cLat + dLat]);
			}
		
			const sid = idPrefix + '-circ-' + Date.now();
			map.addSource(sid, {
			type: 'geojson',
			data: {
				type: 'Feature',
				geometry: { type: 'Polygon', coordinates: [puntos] },
			},
			});
			map.addLayer({
			id: sid + '-fill',
			type: 'fill',
			source: sid,
			paint: { 'fill-color': color, 'fill-opacity': 0.2 },
			});
			map.addLayer({
			id: sid + '-border',
			type: 'line',
			source: sid,
			paint: { 'line-color': color, 'line-width': 2 },
			});
		
			// Popup al click
			map.on('click', sid + '-fill', () => {
			new window.mapboxgl.Popup()
				.setLngLat([cLng, cLat])
				.setHTML(`<strong>⭕ ${titulo}</strong><br>Radio: ${radioM}m`)
				.addTo(map);
			});
		},
		
		// ── Helper: geocerca poligonal ────────────────────────────────────
		_geocercaPoligonal(map, coordenadas, color, titulo, idPrefix) {
			if (!coordenadas || coordenadas.length < 3) return;
			// coordenadas: array de [lat, lng]
			const coords = coordenadas.map(c => [c[1], c[0]]);
			const sid = idPrefix + '-poly-' + Date.now();
			map.addSource(sid, {
			type: 'geojson',
			data: {
				type: 'Feature',
				geometry: { type: 'Polygon', coordinates: [coords] },
			},
			});
			map.addLayer({
			id: sid + '-fill',
			type: 'fill',
			source: sid,
			paint: { 'fill-color': color, 'fill-opacity': 0.2 },
			});
			map.addLayer({
			id: sid + '-border',
			type: 'line',
			source: sid,
			paint: { 'line-color': color, 'line-width': 2 },
			});
			const centroide = coordenadas.reduce(
			(acc, c) => [acc[0] + c[0] / coordenadas.length, acc[1] + c[1] / coordenadas.length],
			[0, 0]
			);
			map.on('click', sid + '-fill', () => {
			new window.mapboxgl.Popup()
				.setLngLat([centroide[1], centroide[0]])
				.setHTML(`<strong>📍 ${titulo}</strong>`)
				.addTo(map);
			});
		},
		
		// ── Helper: parsear geocerca (circular o poligonal) ───────────────
		_dibujarGeocercaMapbox(map, geofence, color, titulo, idPrefix) {
			if (!geofence || typeof geofence !== 'object') return;
		
			if (geofence.type === 'circular') {
			this._geocercaCircular(map, geofence, color, titulo, idPrefix);
			return;
			}
		
			// Formato GeoJSON polygon.coordinates[[[lng, lat], ...]]
			let coordenadas = [];
			if (geofence.polygon?.coordinates) {
			coordenadas = (geofence.polygon.coordinates[0] || [])
				.map(c => {
				const lat = parseFloat(c[1]), lng = parseFloat(c[0]);
				return (!isNaN(lat) && !isNaN(lng)) ? [lat, lng] : null;
				})
				.filter(Boolean);
			} else if (Array.isArray(geofence.polygon)) {
			coordenadas = geofence.polygon
				.map(c => {
				if (!c || c.lat === undefined) return null;
				const lat = parseFloat(c.lat), lng = parseFloat(c.lng);
				return (!isNaN(lat) && !isNaN(lng)) ? [lat, lng] : null;
				})
				.filter(Boolean);
			}
		
			this._geocercaPoligonal(map, coordenadas, color, titulo, idPrefix);
		},
		
		
		// ════════════════════════════════════════════════════════════════════
		// MAPA 1 — map-detalle  (toggleMap / inicializarMapa / destruirMapa)
		// ════════════════════════════════════════════════════════════════════
		
		toggleMap(detalle_mov) {
			this.showMap = !this.showMap;
			if (this.showMap) {
			this.$nextTick(() => {
				this.$nextTick(() => { this.inicializarMapa(detalle_mov); });
			});
			} else {
			this.destruirMapa();
			}
		},
		
		inicializarMapa(detalle_mov) {
			const mapDiv = document.getElementById('map-detalle');
			if (!mapDiv) return;
		
			this.mapInstance = this._destruirMapa(this.mapInstance);
		
			const origenLat  = parseFloat(detalle_mov.sender_latitude);
			const origenLng  = parseFloat(detalle_mov.sender_longitude);
			const destinoLat = parseFloat(detalle_mov.received_latitude);
			const destinoLng = parseFloat(detalle_mov.received_longitude);
		
			const origenValido  = !isNaN(origenLat)  && !isNaN(origenLng);
			const destinoValido = !isNaN(destinoLat) && !isNaN(destinoLng);
		
			if (!origenValido && !destinoValido) {
			mapDiv.innerHTML = `
				<div style="display:flex;align-items:center;justify-content:center;
				height:450px;background:#f8fafb;border-radius:8px;
				border:1px solid #e2e8f0;flex-direction:column;gap:1rem;">
				<i class="pi pi-map" style="font-size:3rem;color:#94a3b8;"></i>
				<p style="color:#64748b;font-size:1rem;margin:0;">
					No hay coordenadas disponibles para este detalle
				</p>
				</div>`;
			return;
			}
		
			// Centro inicial
			let centerLat, centerLng, zoom;
			if (origenValido && destinoValido) {
			centerLat = (origenLat + destinoLat) / 2;
			centerLng = (origenLng + destinoLng) / 2;
			zoom = 10;
			} else if (origenValido) {
			centerLat = origenLat; centerLng = origenLng; zoom = 14;
			} else {
			centerLat = destinoLat; centerLng = destinoLng; zoom = 14;
			}
		
			this.mapInstance = this._crearMapa('map-detalle', [centerLat, centerLng], zoom);
		
			const map = this.mapInstance;
			const boundsPoints = [];
		
			map.on('load', () => {
		
			// Marcador REMITENTE
			if (origenValido) {
				const htmlR = `<div style="background:#1B8A4C;color:white;border-radius:50%;
				width:32px;height:32px;display:flex;align-items:center;
				justify-content:center;font-weight:bold;font-size:13px;
				border:2px solid white;box-shadow:0 2px 6px rgba(0,0,0,.4);">R</div>`;
				this._crearMarcador(
				map, [origenLng, origenLat], htmlR,
				`<strong>📦 Remitente</strong><br>${detalle_mov.sender_name ?? ''}`
				);
				boundsPoints.push([origenLat, origenLng]);
			}
		
			// Marcador DESTINATARIO
			if (destinoValido) {
				const htmlD = `<div style="background:#E53935;color:white;border-radius:50%;
				width:32px;height:32px;display:flex;align-items:center;
				justify-content:center;font-weight:bold;font-size:13px;
				border:2px solid white;box-shadow:0 2px 6px rgba(0,0,0,.4);">D</div>`;
				this._crearMarcador(
				map, [destinoLng, destinoLat], htmlD,
				`<strong>🏁 Destinatario</strong><br>${detalle_mov.receiver_name ?? ''}`
				);
				boundsPoints.push([destinoLat, destinoLng]);
			}
		
			// Línea remitente → destinatario
			if (origenValido && destinoValido) {
				this._crearLinea(
				map,
				[[origenLat, origenLng], [destinoLat, destinoLng]],
				'#0A354E', [3, 3], 'linea-od-detalle'
				);
			}
		
			// Geocercas
			if (detalle_mov.geofence_send && Object.keys(detalle_mov.geofence_send).length) {
				this._dibujarGeocercaMapbox(map, detalle_mov.geofence_send, '#1E88E5',
				detalle_mov.geofence_send.name ?? 'Geocerca Remitente', 'gf-send');
			}
			if (detalle_mov.geofence_received && Object.keys(detalle_mov.geofence_received).length) {
				this._dibujarGeocercaMapbox(map, detalle_mov.geofence_received, '#E53935',
				'Geocerca Destinatario', 'gf-recv');
			}
		
			// Ajustar vista
			if (boundsPoints.length > 1) {
				this._ajustarBounds(map, boundsPoints, 80);
			}
			});
		
			map.on('idle', () => { map.resize(); });
		},
		
		destruirMapa() {
			this.mapInstance = this._destruirMapa(this.mapInstance);
		},
		
		
		// ════════════════════════════════════════════════════════════════════
		// MAPA 2 — map-evento  (openMapModal / inicializarMapaEvento)
		// ════════════════════════════════════════════════════════════════════
		
		openMapModal(evento, detalle_mov) {
			this.eventoSeleccionado      = evento;
			this.detalleMovSeleccionado  = detalle_mov;
			this.modal_mapa_evento       = true;
			this.$nextTick(() => {
			this.$nextTick(() => { this.inicializarMapaEvento(evento, detalle_mov); });
			});
		},
		
		inicializarMapaEvento(evento, detalle_mov) {
			const mapDiv = document.getElementById('map-evento');
			if (!mapDiv) return;
		
			this.mapInstanceEvento = this._destruirMapa(this.mapInstanceEvento);
		
			const eventoLat = parseFloat(evento.latitude);
			const eventoLng = parseFloat(evento.longitude);
			if (isNaN(eventoLat) || isNaN(eventoLng)) return;
		
			this.mapInstanceEvento = this._crearMapa('map-evento', [eventoLat, eventoLng], 13);
			const map = this.mapInstanceEvento;
			const boundsPoints = [];
		
			map.on('load', () => {
		
			const origenLat  = parseFloat(detalle_mov.sender_latitude);
			const origenLng  = parseFloat(detalle_mov.sender_longitude);
			const destinoLat = parseFloat(detalle_mov.received_latitude);
			const destinoLng = parseFloat(detalle_mov.received_longitude);
		
			// Marcador REMITENTE
			if (!isNaN(origenLat) && !isNaN(origenLng)) {
				const htmlR = `<div style="background:#1B8A4C;color:white;border-radius:50%;
				width:32px;height:32px;display:flex;align-items:center;
				justify-content:center;font-weight:bold;font-size:13px;
				border:2px solid white;box-shadow:0 2px 6px rgba(0,0,0,.4);">R</div>`;
				this._crearMarcador(map, [origenLng, origenLat], htmlR,
				`<strong>📦 Remitente</strong><br>${detalle_mov.sender_name ?? ''}`);
				boundsPoints.push([origenLat, origenLng]);
			}
		
			// Marcador DESTINATARIO
			if (!isNaN(destinoLat) && !isNaN(destinoLng)) {
				const htmlD = `<div style="background:#E53935;color:white;border-radius:50%;
				width:32px;height:32px;display:flex;align-items:center;
				justify-content:center;font-weight:bold;font-size:13px;
				border:2px solid white;box-shadow:0 2px 6px rgba(0,0,0,.4);">D</div>`;
				this._crearMarcador(map, [destinoLng, destinoLat], htmlD,
				`<strong>🏁 Destinatario</strong><br>${detalle_mov.receiver_name ?? ''}`);
				boundsPoints.push([destinoLat, destinoLng]);
			}
		
			// Línea remitente → destinatario
			if (!isNaN(origenLat) && !isNaN(origenLng) && !isNaN(destinoLat) && !isNaN(destinoLng)) {
				this._crearLinea(map,
				[[origenLat, origenLng], [destinoLat, destinoLng]],
				'#0A354E', [3, 3], 'linea-od-evento');
			}
		
			// Geocercas
			if (detalle_mov.geofence_send && Object.keys(detalle_mov.geofence_send).length) {
				this._dibujarGeocercaMapbox(map, detalle_mov.geofence_send, '#1E88E5',
				detalle_mov.geofence_send.name ?? 'Geocerca Remitente', 'gfev-send');
			}
			if (detalle_mov.geofence_received && Object.keys(detalle_mov.geofence_received).length) {
				this._dibujarGeocercaMapbox(map, detalle_mov.geofence_received, '#E53935',
				'Geocerca Destinatario', 'gfev-recv');
			}
		
			// Marcador EVENTO (naranja) — se dibuja encima de todo
			const htmlE = `<div style="background:#EB7D10;color:white;border-radius:50%;
				width:36px;height:36px;display:flex;align-items:center;
				justify-content:center;font-weight:bold;font-size:13px;
				border:3px solid white;box-shadow:0 2px 8px rgba(235,125,16,.6);">E</div>`;
			const popupEvento = `
				<strong>📍 ${evento.event_description ?? 'Evento'}</strong><br>
				<small style="color:#64748b">${evento.event_datetime ? this.formatDate(evento.event_datetime) : ''}</small>
				${evento.comment ? `<br><em style="color:#475569">${evento.comment}</em>` : ''}`;
			const markerEvento = this._crearMarcador(map, [eventoLng, eventoLat], htmlE, popupEvento);
			markerEvento.getPopup && markerEvento.togglePopup && markerEvento.togglePopup();
			boundsPoints.push([eventoLat, eventoLng]);
		
			this._ajustarBounds(map, boundsPoints, 80);
			});
		
			map.on('idle', () => { map.resize(); });
		},
		
		destruirMapaEvento() {
			this.mapInstanceEvento = this._destruirMapa(this.mapInstanceEvento);
			this.eventoSeleccionado     = null;
			this.detalleMovSeleccionado = null;
		},
		
		
		// ════════════════════════════════════════════════════════════════════
		// MAPA 3 — map-todos-eventos  (openMapaTodosEventos)
		// ════════════════════════════════════════════════════════════════════
		
		openMapaTodosEventos(detalle_mov) {
			this.detalleMovSeleccionado  = detalle_mov;
			this.modal_mapa_todos_eventos = true;
			this.$nextTick(() => {
			this.$nextTick(() => { this.inicializarMapaTodosEventos(detalle_mov); });
			});
		},
		
		inicializarMapaTodosEventos(detalle_mov) {
			const mapDiv = document.getElementById('map-todos-eventos');
			if (!mapDiv) return;
		
			this.mapInstanceTodosEventos = this._destruirMapa(this.mapInstanceTodosEventos);
		
			const origenLat  = parseFloat(detalle_mov.sender_latitude);
			const origenLng  = parseFloat(detalle_mov.sender_longitude);
		
			// Centro: remitente o primer evento con coordenadas
			const primerEvento = (detalle_mov.events || []).find(e => e.latitude && e.longitude);
			const centerLat = !isNaN(origenLat) ? origenLat : parseFloat(primerEvento?.latitude ?? 4.6);
			const centerLng = !isNaN(origenLng) ? origenLng : parseFloat(primerEvento?.longitude ?? -74.0);
		
			this.mapInstanceTodosEventos = this._crearMapa('map-todos-eventos', [centerLat, centerLng], 11);
			const map = this.mapInstanceTodosEventos;
			const boundsPoints = [];
		
			map.on('load', () => {
		
			const destinoLat = parseFloat(detalle_mov.received_latitude);
			const destinoLng = parseFloat(detalle_mov.received_longitude);
		
			// Marcador REMITENTE
			if (!isNaN(origenLat) && !isNaN(origenLng)) {
				const htmlR = `<div style="background:#1B8A4C;color:white;border-radius:50%;
				width:32px;height:32px;display:flex;align-items:center;
				justify-content:center;font-weight:bold;font-size:13px;
				border:2px solid white;box-shadow:0 2px 6px rgba(0,0,0,.4);">R</div>`;
				this._crearMarcador(map, [origenLng, origenLat], htmlR,
				`<strong>📦 Remitente</strong><br>${detalle_mov.sender_name ?? ''}`);
				boundsPoints.push([origenLat, origenLng]);
			}
		
			// Marcador DESTINATARIO
			if (!isNaN(destinoLat) && !isNaN(destinoLng)) {
				const htmlD = `<div style="background:#E53935;color:white;border-radius:50%;
				width:32px;height:32px;display:flex;align-items:center;
				justify-content:center;font-weight:bold;font-size:13px;
				border:2px solid white;box-shadow:0 2px 6px rgba(0,0,0,.4);">D</div>`;
				this._crearMarcador(map, [destinoLng, destinoLat], htmlD,
				`<strong>🏁 Destinatario</strong><br>${detalle_mov.receiver_name ?? ''}`);
				boundsPoints.push([destinoLat, destinoLng]);
			}
		
			// Línea remitente → destinatario (punteada)
			if (!isNaN(origenLat) && !isNaN(origenLng) && !isNaN(destinoLat) && !isNaN(destinoLng)) {
				this._crearLinea(map,
				[[origenLat, origenLng], [destinoLat, destinoLng]],
				'#0A354E', [3, 3], 'linea-od-todos');
			}
		
			// Geocercas
			if (detalle_mov.geofence_send && Object.keys(detalle_mov.geofence_send).length) {
				this._dibujarGeocercaMapbox(map, detalle_mov.geofence_send, '#1E88E5',
				detalle_mov.geofence_send.name ?? 'Geocerca Remitente', 'gfall-send');
			}
			if (detalle_mov.geofence_received && Object.keys(detalle_mov.geofence_received).length) {
				this._dibujarGeocercaMapbox(map, detalle_mov.geofence_received, '#E53935',
				'Geocerca Destinatario', 'gfall-recv');
			}
		
			// Marcadores de TODOS LOS EVENTOS
			const eventosOrdenados = this.ordenarEventos(detalle_mov.events);
			const eventosConCoords = eventosOrdenados.filter(e => e.latitude && e.longitude);
			const rutaEventos = [];
		
			eventosConCoords.forEach((evento, idx) => {
				const eLat = parseFloat(evento.latitude);
				const eLng = parseFloat(evento.longitude);
				if (isNaN(eLat) || isNaN(eLng)) return;
		
				const htmlE = `<div style="background:#EB7D10;color:white;border-radius:50%;
				width:30px;height:30px;display:flex;align-items:center;
				justify-content:center;font-weight:bold;font-size:11px;
				border:2px solid white;box-shadow:0 2px 6px rgba(235,125,16,.5);">${idx + 1}</div>`;
		
				const popupE = `
				<strong>${idx + 1}. ${evento.event_description ?? 'Evento'}</strong><br>
				<small style="color:#64748b">${evento.event_datetime ? this.formatDate(evento.event_datetime) : ''}</small>
				${evento.comment ? `<br><em style="color:#475569">${evento.comment}</em>` : ''}`;
		
				this._crearMarcador(map, [eLng, eLat], htmlE, popupE);
				boundsPoints.push([eLat, eLng]);
				rutaEventos.push([eLat, eLng]);
			});
		
			// Línea conectando eventos en orden (naranja)
			if (rutaEventos.length > 1) {
				this._crearLinea(map, rutaEventos, '#EB7D10', [2, 2], 'linea-eventos-todos');
			}
		
			// Ajustar bounds
			if (boundsPoints.length > 1) {
				this._ajustarBounds(map, boundsPoints, 80);
			}
			});
		
			map.on('idle', () => { map.resize(); });
		},
		
		destruirMapaTodosEventos() {
			this.mapInstanceTodosEventos = this._destruirMapa(this.mapInstanceTodosEventos);
		},
		limpiarFiltro(campo) {
			if (campo === 'fechasolicitud') {
				this.frmfiltros.fechasolicitud = null;
			} else {
				this.frmfiltros[campo] = '';
			}
			this.cargar_detalle(1);
		},

		formatFiltroFecha(fechas) {
			if (!fechas || fechas.length < 2) return '';
			const opciones = { day: '2-digit', month: '2-digit', year: 'numeric' };
			const inicio = new Date(fechas[0]).toLocaleDateString('es-CO', opciones);
			const fin = new Date(fechas[1]).toLocaleDateString('es-CO', opciones);
			return `${inicio} - ${fin}`;
		},
		cerrarModalDetalle() {
			this.destruirMapa();
			this.modal_detalle = false; // o como se llame tu variable
		},
        getEventoClass(id_event) {
            const classes = {
                2: 'llegada', 3: 'carga', 4: 'carga', 5: 'aceptado',
                6: 'llegada', 7: 'descarga', 8: 'descarga', 9: 'aceptado',
                10: 'pendiente', 11: 'exitoso', 12: 'rechazado', 32: 'aceptado',
            };
            return classes[id_event] || 'default';
            },
        getEventoIcon(id_event) {
			const icons = {
					2: 'pi-truck', 3: 'pi-box', 4: 'pi-check', 5: 'pi-check-circle',
					6: 'pi-building', 7: 'pi-download', 8: 'pi-check', 9: 'pi-check-circle',
					10: 'pi-clock', 11: 'pi-verified', 12: 'pi-times-circle', 32: 'pi-check-circle'
				};
            return `pi ${icons[id_event] || 'pi-circle'}`;
		},
		formatDate(dateString) {
			if (!dateString) return '';
            const match = String(dateString).match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/);
            if (!match) return '';
            const [, year, month, day, hour, minute, second] = match;
            // Se construye con componentes locales (sin pasar por Date.parse/UTC) para que
            // la hora mostrada sea siempre la misma que llega en el string, sin corrimientos
            // por la zona horaria del navegador.
            const date = new Date(+year, +month - 1, +day, +hour, +minute, +(second || 0));
            return date.toLocaleString('es-CO', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
		},
		scrollTimeline(direction) {
            const timeline = document.querySelector('.timeline-track');
            const scrollAmount = 300;
            if (timeline) {
                timeline.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth'
                });
            }
		},
		onChangePage(event) {
			this.cargar_detalle(event.page + 1);
		},
		openGaleriaEventos(imagenes) {
            this.img_eventos = [];
            this.loader = true;
            
            window.api.call('post', 'img_public', {
                imagenes: imagenes,
                nombre_campo_img: 'image_url'
            }).then(response => {
                if (response.status === 200) {
                this.loader = false;
                this.img_eventos = response.data.data.images;
                this.show_galeria_evnets = true;
                }
            }).catch(err => {
                this.loader = false;
                console.error(err);
            });
		},
		getStatusComment(id, comment) {
			if (!id) return 'SIN ESTADO';
			if (id == 30) return 'PENDIENTE';
			return comment?.trim() ? comment : 'SIN ESTADO';
		},
		toggleViaje(viaje) {
			const id = viaje.id_viaje;

			this.expandedViajeId = this.expandedViajeId === id
				? null
				: id;
		},
		isViajeExpanded(viaje) {
			return this.expandedViajeId === viaje.id_viaje;
		},
		getEstadoSeverity(estado) {
			const severityMap = {
				'PENDIENTE': 'warning',
				'ACEPTADO': 'info',
				'EN TRANSITO': 'primary',
				'FINALIZADO': 'success',
				'RECHAZADO': 'danger'
			};
			return severityMap[estado] || 'secondary';
		},
        handleTabChange(event) {
            switch (event.index) {
                case 0:
                    // console.log('a');
                    break;
                case 1:
					this.traer_inspeccion();
                    break;
                default:
                    break;
            }
        },
        traer_inspeccion(){
			this.inspeccion_vehicular = null;
			this.fecha_inspeccion = null;
			var _that = this;
            console.log(this.deliverie);
            console.log(this.id_customer);
            
			this.loader = true;
			var url = 'traerchecklist';
			window.api.call('post', url, {id_customer: this.id_customer,id_deliverie: this.deliverie.delivery_id}).then( function(response) {
				if(response.status == 200){
					if (response.data.inspeccion_vehicular!=null) {
						_that.inspeccion_vehicular = response.data.inspeccion_vehicular.checklist_categories;
						_that.fecha_inspeccion = response.data.inspeccion_vehicular.checklist_general_date ?? '';
					}
					_that.loader = false;
				}
			}).catch(function (err) {
				_that.loader = false;
				console.log(err);
				if (err.status==414) {
					_that.$toast.add({severity:'warn', summary: 'Falta información', detail:err.data.message, life: 4000});
				}

			});
		},
		validarEmail() {
			const email = this.frmUsuario.email;
			if (!email) {
				this.erroresValidacion.email = 'El email es requerido';
				return false;
			}
			
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (!emailRegex.test(email)) {
				this.erroresValidacion.email = 'Formato de email inválido';
				return false;
			}
			
			if (email.length > 100) {
				this.erroresValidacion.email = 'El email no puede tener más de 100 caracteres';
				return false;
			}
			
			return true;
		},

		validarPlaca() {
			const placa = this.frmUsuario.placa;
			if (!placa) {
				this.erroresValidacion.placa = 'La placa es requerida';
				return false;
			}
			
			// Formato ABC-123 o ABC123
			const placaRegex = /^[A-Z]{3}[-]?[0-9]{3}$/;
			if (!placaRegex.test(placa.toUpperCase())) {
				this.erroresValidacion.placa = 'Formato inválido. Use ABC-123 o ABC123';
				return false;
			}
			
			return true;
		},

		validarDocumentoReferencia() {
			const documento = this.frmUsuario.reference_document;
			if (!documento) {
				this.erroresValidacion.reference_document = 'El documento es requerido';
				return false;
			}
			
			const numeroDoc = parseInt(documento);
			if (isNaN(numeroDoc) || numeroDoc <= 0) {
				this.erroresValidacion.reference_document = 'Debe ser un número válido mayor a 0';
				return false;
			}
			
			if (documento.length < 3 || documento.length > 20) {
				this.erroresValidacion.reference_document = 'Debe tener entre 3 y 20 dígitos';
				return false;
			}
			
			return true;
		},

		validarValorViaje() {
			const valor = this.frmUsuario.valor_viaje;
			if (!valor) {
				this.erroresValidacion.valor_viaje = 'El valor del viaje es requerido';
				return false;
			}
			
			if (valor <= 0) {
				this.erroresValidacion.valor_viaje = 'El valor debe ser mayor a $0';
				return false;
			}
			
			if (valor > 999999999) {
				this.erroresValidacion.valor_viaje = 'El valor es demasiado alto';
				return false;
			}
			
			return true;
		},

		validarDocumentoRepresentante() {
			return this.validarDocumentoGenerico(
				this.frmUsuario.representative_id, 
				'representative_id', 
				'documento del representante'
			);
		},

		validarNombreRepresentante() {
			return this.validarNombreGenerico(
				this.frmUsuario.representative, 
				'representative', 
				'nombre del representante'
			);
		},

		validarDocumentoPropietario() {
			return this.validarDocumentoGenerico(
				this.frmUsuario.owner_id, 
				'owner_id', 
				'documento del propietario'
			);
		},

		validarNombrePropietario() {
			return this.validarNombreGenerico(
				this.frmUsuario.owner, 
				'owner', 
				'nombre del propietario'
			);
		},

		validarHorasValidacion() {
			const horas = this.frmUsuario.hours_validation;
			if (!horas) {
				this.erroresValidacion.hours_validation = 'Las horas son requeridas';
				return false;
			}
			
			const numeroHoras = parseInt(horas);
			if (isNaN(numeroHoras) || numeroHoras <= 0) {
				this.erroresValidacion.hours_validation = 'Debe ser un número válido mayor a 0';
				return false;
			}
			
			if (numeroHoras > 8760) { // 1 año = 8760 horas
				this.erroresValidacion.hours_validation = 'Máximo 8760 horas (1 año)';
				return false;
			}
			
			return true;
		},

		// ===== VALIDACIONES PARA DETALLES =====
		
		validarCampoDetalle(index, campo) {
			const detalle = this.detalles_viaje[index];
			const valor = detalle[campo];
			
			if (!detalle.errores) {
				this.$set(detalle, 'errores', {});
			}
			
			if (!valor || valor.trim() === '') {
				if (['ciudad_origen', 'departamento_origen', 'ciudad_destino', 'departamento_destino', 
					 'send_city', 'send_country', 'received_city', 'received_country', 'producto'].includes(campo)) {
					this.$set(detalle.errores, campo, 'Campo requerido');
					return false;
				}
			} else {
				// Validar longitud
				if (valor.length < 2) {
					this.$set(detalle.errores, campo, 'Mínimo 2 caracteres');
					return false;
				}
				if (valor.length > 100) {
					this.$set(detalle.errores, campo, 'Máximo 100 caracteres');
					return false;
				}
				
				// Validar caracteres especiales para nombres de lugares
				if (['ciudad_origen', 'departamento_origen', 'ciudad_destino', 'departamento_destino',
					 'send_city', 'send_country', 'received_city', 'received_country'].includes(campo)) {
					const caracteresPermitidos = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/;
					if (!caracteresPermitidos.test(valor)) {
						this.$set(detalle.errores, campo, 'Solo se permiten letras y espacios');
						return false;
					}
				}
			}
			
			return true;
		},

		validarDocumentoDetalle(index, campo) {
			const detalle = this.detalles_viaje[index];
			const valor = detalle[campo];
			
			if (!detalle.errores) {
				this.$set(detalle, 'errores', {});
			}
			
			if (!valor) {
				this.$set(detalle.errores, campo, 'Campo requerido');
				return false;
			}
			
			const numero = parseInt(valor);
			if (isNaN(numero) || numero <= 0) {
				this.$set(detalle.errores, campo, 'Debe ser un número válido mayor a 0');
				return false;
			}
			
			if (valor.length < 3 || valor.length > 20) {
				this.$set(detalle.errores, campo, 'Entre 3 y 20 dígitos');
				return false;
			}
			
			return true;
		},

		validarNombreDetalle(index, campo) {
			const detalle = this.detalles_viaje[index];
			const valor = detalle[campo];
			
			if (!detalle.errores) {
				this.$set(detalle, 'errores', {});
			}
			
			if (!valor || valor.trim() === '') {
				this.$set(detalle.errores, campo, 'Campo requerido');
				return false;
			}
			
			if (valor.length < 2) {
				this.$set(detalle.errores, campo, 'Mínimo 2 caracteres');
				return false;
			}
			
			if (valor.length > 100) {
				this.$set(detalle.errores, campo, 'Máximo 100 caracteres');
				return false;
			}
			
			const nombreRegex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s\.]+$/;
			if (!nombreRegex.test(valor)) {
				this.$set(detalle.errores, campo, 'Solo letras, espacios y puntos');
				return false;
			}
			
			return true;
		},

		validarPesoDetalle(index) {
			const detalle = this.detalles_viaje[index];
			const peso = detalle.peso;
			
			if (!detalle.errores) {
				this.$set(detalle, 'errores', {});
			}
			
			if (!peso || peso <= 0) {
				this.$set(detalle.errores, 'peso', 'El peso debe ser mayor a 0');
				return false;
			}
			
			if (peso > 50000) { // 50 toneladas
				this.$set(detalle.errores, 'peso', 'Peso máximo: 50,000 kg');
				return false;
			}
			
			return true;
		},

		validarUnidadesDetalle(index) {
			const detalle = this.detalles_viaje[index];
			const unidades = detalle.unidades;
			
			if (!detalle.errores) {
				this.$set(detalle, 'errores', {});
			}
			
			if (!unidades || unidades <= 0) {
				this.$set(detalle.errores, 'unidades', 'Las unidades deben ser mayor a 0');
				return false;
			}
			
			if (unidades > 100000) {
				this.$set(detalle.errores, 'unidades', 'Máximo 100,000 unidades');
				return false;
			}
			
			// Verificar que sea entero
			if (unidades % 1 !== 0) {
				this.$set(detalle.errores, 'unidades', 'Debe ser un número entero');
				return false;
			}
			
			return true;
		},

		validarEmailDetalle(index, campo = 'email') {
			const detalle = this.detalles_viaje[index];
			const email = detalle[campo];
			if (!detalle.errores) this.$set(detalle, 'errores', {});
			if (email && email.trim() !== '') {
				const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				if (!emailRegex.test(email)) {
					this.$set(detalle.errores, campo, 'Formato de email inválido');
					return false;
				}
			}
			return true;
		},

		validarTelefonoDetalle(index, campo) {
			const detalle = this.detalles_viaje[index];
			const telefono = detalle[campo];
			
			if (!detalle.errores) {
				this.$set(detalle, 'errores', {});
			}
			
			// Teléfonos son opcionales
			if (telefono && telefono.trim() !== '') {
				// Solo números, espacios, guiones y paréntesis
				const telefonoRegex = /^[\d\s\-\(\)\+]+$/;
				if (!telefonoRegex.test(telefono)) {
					this.$set(detalle.errores, campo, 'Solo números, espacios, guiones y paréntesis');
					return false;
				}
				
				// Remover espacios y caracteres especiales para contar dígitos
				const soloDigitos = telefono.replace(/\D/g, '');
				if (soloDigitos.length < 7 || soloDigitos.length > 15) {
					this.$set(detalle.errores, campo, 'Entre 7 y 15 dígitos');
					return false;
				}
			}
			
			return true;
		},

		// ===== FUNCIONES AUXILIARES =====
		
		validarDocumentoGenerico(valor, campo, nombreCampo) {
			if (!valor) {
				this.erroresValidacion[campo] = `El ${nombreCampo} es requerido`;
				return false;
			}
			
			const numero = parseInt(valor);
			if (isNaN(numero) || numero <= 0) {
				this.erroresValidacion[campo] = 'Debe ser un número válido mayor a 0';
				return false;
			}
			
			if (valor.length < 3 || valor.length > 20) {
				this.erroresValidacion[campo] = 'Debe tener entre 3 y 20 dígitos';
				return false;
			}
			
			return true;
		},

		validarNombreGenerico(valor, campo, nombreCampo) {
			if (!valor || valor.trim() === '') {
				this.erroresValidacion[campo] = `El ${nombreCampo} es requerido`;
				return false;
			}
			
			if (valor.length < 2) {
				this.erroresValidacion[campo] = 'Mínimo 2 caracteres';
				return false;
			}
			
			if (valor.length > 100) {
				this.erroresValidacion[campo] = 'Máximo 100 caracteres';
				return false;
			}
			
			const nombreRegex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s\.]+$/;
			if (!nombreRegex.test(valor)) {
				this.erroresValidacion[campo] = 'Solo se permiten letras, espacios y puntos';
				return false;
			}
			
			return true;
		},

		limpiarError(campo) {
			if (this.erroresValidacion[campo]) {
				this.$delete(this.erroresValidacion, campo);
			}
		},

		limpiarErrorDetalle(index, campo) {
			const detalle = this.detalles_viaje[index];
			if (detalle.errores && detalle.errores[campo]) {
				this.$delete(detalle.errores, campo);
			}
		},

		// ===== VALIDACIÓN COMPLETA DEL FORMULARIO =====
		
		validarFormularioCompleto() {
			let esValido = true;
			
			// Validar formulario principal
			if (!this.validarEmail()) esValido = false;
			if (!this.validarPlaca()) esValido = false;
			if (!this.validarDocumentoReferencia()) esValido = false;
			if (!this.validarValorViaje()) esValido = false;
			if (!this.validarDocumentoRepresentante()) esValido = false;
			if (!this.validarNombreRepresentante()) esValido = false;
			if (!this.validarDocumentoPropietario()) esValido = false;
			if (!this.validarNombrePropietario()) esValido = false;
			if (!this.validarHorasValidacion()) esValido = false;
			
			// Validar detalles
			this.detalles_viaje.forEach((detalle, index) => {
				detalle.submitted = true;
				
				// Campos requeridos del detalle
				if (!this.validarCampoDetalle(index, 'ciudad_origen')) esValido = false;
				if (!this.validarCampoDetalle(index, 'departamento_origen')) esValido = false;
				if (!this.validarCampoDetalle(index, 'ciudad_destino')) esValido = false;
				if (!this.validarCampoDetalle(index, 'departamento_destino')) esValido = false;
				if (!this.validarDocumentoDetalle(index, 'send_id')) esValido = false;
				if (!this.validarNombreDetalle(index, 'send_name')) esValido = false;
				if (!this.validarCampoDetalle(index, 'send_city')) esValido = false;
				if (!this.validarCampoDetalle(index, 'send_country')) esValido = false;
				if (!this.validarDocumentoDetalle(index, 'received_id')) esValido = false;
				if (!this.validarNombreDetalle(index, 'received_name')) esValido = false;
				if (!this.validarCampoDetalle(index, 'received_city')) esValido = false;
				if (!this.validarCampoDetalle(index, 'received_country')) esValido = false;
				if (!this.validarCampoDetalle(index, 'producto')) esValido = false;
				if (!this.validarPesoDetalle(index)) esValido = false;
				if (!this.validarUnidadesDetalle(index)) esValido = false;
				if (!this.validarDocumentoDetalle(index, 'id_cliente')) esValido = false;
				if (!this.validarNombreDetalle(index, 'nombre_cliente')) esValido = false;
				
				// Campos opcionales pero validados si están llenos
				this.validarEmailDetalle(index);
				this.validarTelefonoDetalle(index, 'telefono');
				this.validarTelefonoDetalle(index, 'celular');
			});
			
			return esValido;
		}
	},
	computed: {
        // isRTL() {
        //     return this.$appState.RTL;
        // },
        validMinDate() {
            return this.frmfiltros.fechasolicitud ? new Date(this.frmfiltros.fechasolicitud) : null;
        },
		tieneFiltrosActivos() {
			return (
				!!this.frmfiltros.placa ||
				!!this.frmfiltros.external_reference ||
				!!this.frmfiltros.driver_document_id ||
				(this.frmfiltros.fechasolicitud && this.frmfiltros.fechasolicitud.length === 2)
			);
		},
		fechaFormateada() {
			if (!this.fecha_consulta) return '';

			const fecha = new Date(this.fecha_consulta);

			return fecha.toLocaleString('es-CO', {
				day: '2-digit',
				month: 'short',
				year: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
				hour12: true
			});
		},
		departamentosUnicos() {
			if (!this.divipola || !this.divipola.length) return [];
			const deps = [...new Set(this.divipola.map(d => d.departamento))].sort();
			return deps.map(d => ({ label: d, value: d }));
		},
		municipiosPorDepartamento() {
			return (departamento) => {
				if (!departamento || !this.divipola.length) return [];
				return this.divipola
					.filter(d => d.departamento === departamento)
					.map(d => ({ label: d.municipio, value: d.municipio }))
					.sort((a, b) => a.label.localeCompare(b.label));
			};
		},
		tasaExito() {
			const total     = this.indicadores_viajes.total_deliveries || 0;
			const finalizado = this.indicadores_viajes.total_finalizado || 0;
			if (!total) return 0;
			return Math.round((finalizado / total) * 100);
		},
    },
    components: {
        'InspeccionVehicular': InspeccionVehicular,
        'ModalCrearViaje3Pasos': ModalCrearViaje3Pasos,
    },
};
</script>
<style scoped lang="scss">
:root {
	--primary: #1a5f7a;
	--primary-light: #e8f2f7;
	--accent: #57c5b6;
	--accent-light: #e8f7f5;
	--surface: #ffffff;
	--surface-secondary: #f8fafb;
	--text-primary: #1e293b;
	--text-secondary: #64748b;
	--border: #e2e8f0;
	--success: #10b981;
	--success-light: #d1fae5;
	--warning: #f59e0b;
	--warning-light: #fef3c7;
	--error: #ef4444;
	--error-light: #fee2e2;
	--info: #3b82f6;
	--info-light: #dbeafe;
}

.tabla-viajes{
	font-size: 0.9rem;
}

.cliente-header-premium {
    width: 100%;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 16px 20px;
    margin-bottom: 16px;
    background: #fff;
}

.cliente-titulo {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 12px;
}

.cliente-titulo .label {
    font-size: 11px;
    color: #6b7280;
    font-weight: 600;
    letter-spacing: .5px;
}

.cliente-nombre {
    font-size: 14px;
    font-weight: 700;
    color: #111827;
}

.cliente-info {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 12px;
}

.info-label {
    display: block;
    font-size: 11px;
    color: #6b7280;
    font-weight: 600;
}

.info-value {
    font-size: 13px;
    color: #111827;
}


.p-datatable table {
	width: 100%;
	border-collapse: collapse;
    min-width: 100%;
    table-layout: fixed;
}

.viajes-container-modern {
	background: var(--surface-secondary);
	min-height: 100vh;
	padding: 1.5rem;
}

// Header
.viajes-header-modern {
	background: var(--surface);
	border-radius: 12px;
	padding: 1.25rem 1.5rem;
	margin-bottom: 1.5rem;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
	border: 1px solid var(--border);

	.header-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 1rem;
		flex-wrap: wrap;
	}

	.header-left {
		display: flex;
		align-items: center;
		gap: 1rem;
		flex: 1;
	}

	.header-title {
		h2 {
			margin: 0;
			font-size: 1.25rem;
			font-weight: 600;
			color: var(--text-primary);
		}

		.total-badge {
			display: inline-block;
			background: var(--primary-light);
			color: var(--primary);
			padding: 0.25rem 0.75rem;
			border-radius: 20px;
			font-size: 0.8125rem;
			font-weight: 600;
			margin-left: 0.5rem;
		}
	}

	.header-actions {
		display: flex;
		gap: 0.75rem;
		
		.p-button {
			font-size: 0.9375rem;
			padding: 0.625rem 1.25rem;
			border-radius: 8px;
		}
	}
}

// Panel de filtros
.filters-panel {
	padding: 1rem 0;

	.filters-title {
		display: flex;
		align-items: center;
		color: #1e293b;
		font-size: 1.125rem;
		font-weight: 600;
		margin-bottom: 1.5rem;
	}
}

// Viajes cards - diseño profesional pastel
.viajes-table-modern {
	display: flex;
	flex-direction: column;
	gap: 1rem;
}

.viaje-card-modern {
	background: var(--surface);
	border-radius: 10px;
	overflow: hidden;
	transition: all 0.2s ease;
	border: 1px solid var(--border);

	&:hover {
		transform: translateY(-1px);
	}

	.viaje-header {
		display: flex;
		align-items: center;
		padding: 1.25rem 1.5rem;
		cursor: pointer;
		transition: background 0.15s;
		border-bottom: 1px solid transparent;

		&:hover {
			background: #047857;
			// background: var(--surface-secondary);
		}
	}

	.viaje-info-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
		gap: 1.25rem;
		flex: 1;
	}

	.info-block {
		display: flex;
		gap: 0.875rem;
		align-items: flex-start;
	}

	.info-icon {
		width: 38px;
		height: 38px;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		font-size: 1.125rem;

		&.blue { 
			background: var(--info-light);
			color: var(--info);
		}
		&.green { 
			background: var(--success-light);
			color: var(--success);
		}
		&.orange { 
			background: var(--warning-light);
			color: var(--warning);
		}
		&.purple { 
			background: #f3e8ff;
			color: #9333ea;
		}
		&.pink { 
			background: #fce7f3;
			color: #ec4899;
		}
		&.teal { 
			background: #ccfbf1;
			color: #0d9488;
		}
	}

	.info-content {
		display: flex;
		flex-direction: column;
		gap: 0.25rem;
	}

	.info-label {
		font-size: 0.75rem;
		color: #64748b;
		text-transform: uppercase;
		font-weight: 600;
		letter-spacing: 0.5px;
	}

	.info-value {
		font-size: 1rem;
		color: #1e293b;
		font-weight: 700;
	}

	.info-sublabel {
		font-size: 0.875rem;
		color: #94a3b8;
	}

	.entregas-stats {
		display: flex;
		gap: 0.5rem;
		flex-wrap: wrap;
	}

	.expand-button {
		width: 40px;
		height: 40px;
		border-radius: 10px;
		background: #f1f5f9;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: all 0.3s;
		flex-shrink: 0;

		i {
			color: #64748b;
			font-size: 1rem;
		}

		&:hover {
			background: #e2e8f0;
		}
	}
}

.last-update {
    // margin-top: 0.75rem;
    text-align: right;
    font-size: 0.85rem;
    color: #6b7280; /* gris similar al ejemplo */
}

// Contenido expandible
.viaje-content {
	border-top: 1px solid #f1f5f9;
	padding: 1.5rem;
	background: #fafbfc;
}

.expand-enter-active, .expand-leave-active {
	transition: all 0.3s ease;
	max-height: 1000px;
}

.expand-enter-from, .expand-leave-to {
	max-height: 0;
	opacity: 0;
}

// Tabs modernos
:deep(.viaje-tabs-modern) {
	.p-tabview-nav {
		background: white;
		border-radius: 12px;
		padding: 0.5rem;
		border: none;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

		.p-tabview-nav-link {
			border: none;
			padding: 0.75rem 1.25rem;
			border-radius: 8px;
			font-weight: 600;
			color: #64748b;
			transition: all 0.2s;

			&:hover {
				background: #f8fafb;
				color: #1e293b;
			}
		}

		.p-highlight .p-tabview-nav-link {
			background: #0A354E;
			color: white;
		}
	}

	.p-tabview-panels {
		background: white;
		border-radius: 12px;
		padding: 1.5rem;
		margin-top: 1rem;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
	}
}

// Empty state
.empty-state {
	text-align: center;
	padding: 4rem 2rem;
	background: white;
	border-radius: 16px;

	.empty-icon {
		font-size: 4rem;
		color: #cbd5e1;
		margin-bottom: 1rem;
	}

	h3 {
		color: #1e293b;
		margin-bottom: 0.5rem;
	}

	p {
		color: #64748b;
	}
}

// Paginación moderna
.pagination-modern {
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: white;
	padding: 1rem 1.5rem;
	border-radius: 16px;
	margin-top: 1.5rem;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

	.pagination-info {
		color: #64748b;
		font-size: 0.875rem;
		font-weight: 500;
	}
}

// Responsive
@media (max-width: 1024px) {
	.viaje-info-grid {
		grid-template-columns: repeat(3, 1fr);
	}
}

@media (max-width: 768px) {
	.viajes-container-modern {
		padding: 1rem;
	}

	.viajes-header-modern {
		.header-content {
			flex-direction: column;
			align-items: stretch;
		}

		.header-left {
			flex-direction: column;
			align-items: flex-start;
		}

		.header-actions {
			width: 100%;

			button {
				flex: 1;
			}
		}
	}

	.viaje-info-grid {
		grid-template-columns: repeat(2, 1fr);
	}

	.viaje-header {
		flex-direction: column;
		gap: 1rem;
	}

	.expand-button {
		align-self: stretch;
		width: 100%;
	}

	.pagination-modern {
		flex-direction: column;
		gap: 1rem;
	}
}

@media (max-width: 480px) {
	.viaje-info-grid {
		grid-template-columns: 1fr;
	}
}

@media (max-width: 480px) {
	.viaje-info-grid {
		grid-template-columns: 1fr;
	}
}
.widget-activity > li:nth-child(1) .p-progressbar-value {
    background: #75BEF8;
}
/* .indicadores-fijos{
	position: fixed;
    z-index: 1000;
	margin-left: 50px;
} */

.header-landing-seway{
    /* position: fixed; */
    z-index: 100;
    /* padding: 0rem 3rem 0rem 0rem; */
}
.p-menubar {
  /* padding: 0.75rem; */
  background: transparent;
/* //   color: rgba(255, 255, 255, 0.87); */
  border: 1px transparent;
  border-radius: 4px;
}
.button-menu-seway{
    background: #EB7D10;
    color: white;
}
.button-menu-seway:hover{
    background: #0A354E;
    color: white;
}

/* //moviles */
@media only screen and (max-width: 800px) {
    .landing-container #header .header-menu-container {
        z-index: 100;
        position: fixed;
        top: 0;
        left: 0;
        /* // width: 73%; */
        /* background: #212121; */
        /* padding: 2rem 1rem; */
    }
}
.dashboard-movimientos-container {
    background: linear-gradient(135deg, #ffffff 0%, #f8fcff 100%);
    min-height: 100vh;
}

/* // Header mejorado */
.dashboard-header-movimientos {
    text-align: center;
    color: rgb(0, 0, 0);
    margin-bottom: 3rem;
    margin-top: 2rem;
    animation: fadeInDown 0.6s ease-out;

    h1 {
        font-size: 2.5rem;
        font-weight: 700;
        margin-bottom: 0.5rem;
        text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }

    p {
        font-size: 1.1rem;
        opacity: 0.9;
    }
}

/* // Grid de indicadores mejorado */
.indicators-modern-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1.5rem;
    margin-bottom: 3rem;
}

.indicator-card-modern {
    background: white;
    border-radius: 20px;
    padding: 1.5rem;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    animation: fadeInUp 0.6s ease-out backwards;

    &:nth-child(1) { animation-delay: 0.1s; }
    &:nth-child(2) { animation-delay: 0.2s; }
    &:nth-child(3) { animation-delay: 0.3s; }
    &:nth-child(4) { animation-delay: 0.4s; }
    &:nth-child(5) { animation-delay: 0.5s; }
    &:nth-child(6) { animation-delay: 0.6s; }

    &:hover {
        transform: translateY(-10px) scale(1.02);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);

        .indicator-icon-modern {
            transform: rotate(10deg) scale(1.1);
        }

        .indicator-badge-modern {
            opacity: 1;
        }
    }

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 5px;
        background: linear-gradient(90deg, var(--color-start), var(--color-end));
    }

    &.total {
        // --color-start: #0A354E;
        // --color-end: #1a5f8f;
		--color-start: rgb(117, 180, 225);
        --color-end: rgba(212, 238, 255, 1);
    }

    &.pendientes {
        --color-start: #60A5FA;
        --color-end: #3B82F6;
    }

    &.aceptados {
        --color-start: #34D399;
        --color-end: #10B981;
    }

    &.transito {
        --color-start: #FBBF24;
        --color-end: #F59E0B;
    }

    &.finalizado {
        --color-start: #A78BFA;
        --color-end: #8B5CF6;
    }

    &.rechazados {
        --color-start: #F472B6;
        --color-end: #EC4899;
    }

	&.anulados {
        --color-start: #b8a7b0;
        --color-end: rgb(214, 199, 207);
    }
}

.indicator-icon-modern {
    width: 60px;
    height: 60px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    background: linear-gradient(135deg, var(--color-start), var(--color-end));
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
    transition: transform 0.3s ease;

    i {
        font-size: 1.6rem;  // ← tamaño del ícono
        color: white;       // ← siempre blanco sobre el gradiente
    }
}

.indicator-title-modern {
    font-size: 0.85rem;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 0.5rem;
}

.indicator-value-modern {
    font-size: 2.5rem;
    font-weight: 800;
    background: linear-gradient(135deg, var(--color-start), var(--color-end));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    line-height: 1;
}

.indicator-badge-modern {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: linear-gradient(135deg, var(--color-start), var(--color-end));
    color: white;
    padding: 0.25rem 0.75rem;
    border-radius: 20px;
    font-size: 0.7rem;
    font-weight: 600;
    opacity: 0;
    transition: opacity 0.3s ease;
}

// Sección de gráficas mejorada
.charts-section-modern {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
    gap: 2rem;
    animation: fadeIn 0.8s ease-out 0.6s backwards;
}

.chart-card-modern {
    background: white;
    border-radius: 20px;
    padding: 2rem;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;

    &:hover {
        transform: translateY(-5px);
    }
}

.chart-header-modern {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.5rem;

    .chart-title-modern {
        font-size: 1.25rem;
        font-weight: 700;
        color: #1e293b;
    }

    .chart-icon-modern {
        width: 40px;
        height: 40px;
        border-radius: 10px;
        background: linear-gradient(135deg, #105277, #0A354E);
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 1.2rem;
    }
}

.chart-wrapper-modern {
    height: 300px;
    margin-bottom: 1.5rem;

    :deep(.p-chart) {
        height: 100%;
        
        canvas {
            height: 100% !important;
        }
    }
}

.stats-grid-modern {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
}

.stat-item-modern {
    text-align: center;
    padding: 1rem;
    background: #f8fafc;
    border-radius: 12px;
    transition: all 0.3s ease;

    &:hover {
        background: #e2e8f0;
        transform: scale(1.05);
    }

    .stat-label-modern {
        font-size: 0.75rem;
        color: #64748b;
        text-transform: uppercase;
        margin-bottom: 0.5rem;
    }

    .stat-value-modern {
        font-size: 1.5rem;
        font-weight: 700;
        color: #1e293b;

        &.blue { color: #3B82F6; }
        &.green { color: #10B981; }
        &.orange { color: #F59E0B; }
        &.purple { color: #8B5CF6; }
        &.pink { color: #EC4899; }
        &.dark { color: #0A354E; }
    }
}

/* // Animaciones */
@keyframes fadeInDown {
    from {
        opacity: 0;
        transform: translateY(-30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

/* // Responsive */
@media (max-width: 1024px) {
    .indicators-modern-grid {
        grid-template-columns: repeat(3, 1fr);
    }

    .charts-section-modern {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    .dashboard-movimientos-container {
        padding: 1rem;
    }

    .dashboard-header-movimientos h1 {
        font-size: 1.8rem;
    }

    .indicators-modern-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
    }

    .indicator-value-modern {
        font-size: 2rem;
    }

    .stats-grid-modern {
        grid-template-columns: repeat(2, 1fr);
    }

    .chart-card-modern {
        padding: 1.5rem;
    }
}

@media (max-width: 480px) {
    .indicators-modern-grid {
        grid-template-columns: 1fr;
    }

    .indicator-card-modern {
        padding: 1.25rem;
    }

    .stats-grid-modern {
        grid-template-columns: 1fr;
    }
}
// Estilos para Modal Crear Viaje - Versión Limpia
:deep(.modal-crear-viaje) {
	.p-dialog-content {
		padding: 0 !important;
	}

	.p-tabview {
		.p-tabview-nav {
			background: #ffffff;
			border-bottom: 1px solid #e5e7eb;

			.p-tabview-nav-link {
				padding: 1rem 1.5rem;
				font-weight: 600;
				color: #6b7280;
				
				&:hover {
					background: #f9fafb;
					color: #374151;
				}
			}

			.p-highlight .p-tabview-nav-link {
				color: #0A354E;
				border-color: #062334;
			}
		}

		.p-tabview-panels {
			padding: 1.5rem;
			background: #fafafa;
		}
	}
}

// Headers de sección - más sutiles
.section-header {
	display: flex;
	align-items: center;
	padding: 0.875rem 1rem;
	background: #ffffff;
	border-left: 4px solid #0A354E;
	border-radius: 6px;
	margin-bottom: 1.25rem;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

	.section-title {
		font-size: 0.95rem;
		font-weight: 600;
		color: #1f2937;
	}

	i {
		font-size: 1.1rem;
		color: #0A354E;
		margin-right: 0.75rem;
	}
}

.section-header-detalles {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.875rem 1rem;
	background: #ffffff;
	border-left: 4px solid #10b981;
	border-radius: 6px;
	margin-bottom: 1.25rem;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

	.section-title {
		font-size: 0.95rem;
		font-weight: 600;
		color: #1f2937;
	}

	i {
		font-size: 1.1rem;
		color: #10b981;
		margin-right: 0.75rem;
	}

	.p-button {
		font-size: 0.875rem;
		padding: 0.5rem 1rem;
	}
}

.subsection-header {
	display: flex;
	align-items: center;
	padding: 0.625rem 1rem;
	background: #f9fafb;
	border-left: 3px solid #0A354E;
	border-radius: 4px;
	margin-bottom: 1rem;
	font-weight: 600;
	font-size: 0.9rem;
	color: #374151;

	i {
		color: #0A354E;
		font-size: 1rem;
	}
}

// Message info más sutil
:deep(.p-message.p-message-info) {
	background: #eff6ff;
	border: 1px solid #dbeafe;
	color: #1e40af;
	padding: 0.75rem 1rem;
	margin-bottom: 1rem;

	.p-message-icon {
		color: #3b82f6;
	}
}

:deep(.p-message.p-message-warn) {
	background: #fef3c7;
	border: 1px solid #fde68a;
	color: #92400e;
	padding: 0.75rem 1rem;

	.p-message-icon {
		color: #f59e0b;
	}
}


.accordion-header-custom {
	display: flex;
	align-items: center;
	gap: 1rem;
	width: 100%;

	.badge-detalle {
		background: #eef2ff;
		color: #0A354E;
		border: 1px solid #c7d2fe;
		padding: 0.25rem 0.75rem;
		border-radius: 6px;
		font-size: 0.8125rem;
		font-weight: 600;
	}

	.text-sm {
		color: #6b7280;
		font-size: 0.875rem;
	}
}

.detalle-form {
	background: #f9fafb;
	padding: 1.25rem;
	border-radius: 6px;
	border: 1px solid #e5e7eb;
}

// Tabla de resumen
:deep(.detalles-table) {
	.p-datatable-wrapper {
		border-radius: 8px;
		overflow: hidden;
	}

	.p-datatable-thead > tr > th {
		background: #f9fafb;
		color: #374151;
		font-weight: 600;
		padding: 0.875rem 1rem;
		border: none;
		border-bottom: 2px solid #e5e7eb;
		font-size: 0.875rem;
	}

	.p-datatable-tbody > tr {
		transition: all 0.2s ease;
		background: #ffffff;

		&:hover {
			background: #f9fafb;
		}

		> td {
			padding: 0.875rem 1rem;
			border-bottom: 1px solid #f3f4f6;
			font-size: 0.875rem;
		}
	}

	.p-tag {
		font-size: 0.75rem;
		padding: 0.25rem 0.5rem;
	}
}

// Tab de importación Excel
.import-header {
	text-align: center;
	padding: 2.5rem 2rem;
	background: #ffffff;
	border: 1px solid #e5e7eb;
	border-radius: 12px;
	margin-bottom: 1.5rem;

	.import-icon {
		width: 70px;
		height: 70px;
		margin: 0 auto 1.25rem;
		background: linear-gradient(135deg, #0f4e73 0%, #0A354E 100%);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);

		i {
			font-size: 2rem;
			color: white;
		}
	}

	h3 {
		color: #1f2937;
		font-size: 1.375rem;
		margin-bottom: 0.5rem;
		font-weight: 600;
	}

	p {
		color: #6b7280;
		font-size: 0.9375rem;
		max-width: 600px;
		margin: 0 auto;
		line-height: 1.6;
	}
}

.download-template-card {
	display: flex;
	align-items: center;
	gap: 1.5rem;
	padding: 1.5rem;
	background: #ffffff;
	border: 1px solid #e5e7eb;
	border-radius: 10px;
	transition: all 0.3s ease;
	margin-bottom: 1.5rem;

	&:hover {
		border-color: #10b981;
		box-shadow: 0 4px 12px rgba(16, 185, 129, 0.08);
	}

	.template-icon {
		width: 56px;
		height: 56px;
		background: linear-gradient(135deg, #10b981 0%, #059669 100%);
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;

		i {
			font-size: 1.75rem;
			color: white;
		}
	}

	.template-info {
		flex: 1;

		h4 {
			margin: 0 0 0.375rem 0;
			color: #1f2937;
			font-size: 1.0625rem;
			font-weight: 600;
		}

		p {
			margin: 0 0 0.75rem 0;
			color: #6b7280;
			font-size: 0.875rem;
		}
	}
}

.upload-area {
	text-align: center;
	padding: 3rem 2rem;
	border: 2px dashed #d1d5db;
	border-radius: 12px;
	background: #ffffff;
	transition: all 0.3s ease;
	cursor: pointer;

	&:hover, &.drag-over {
		border-color: #0A354E;
		background: #f5f7ff;

		.upload-icon {
			color: #0A354E;
			transform: translateY(-4px);
		}
	}

	.upload-icon {
		font-size: 3.5rem;
		color: #d1d5db;
		margin-bottom: 1rem;
		transition: all 0.3s ease;
	}

	h4 {
		color: #1f2937;
		margin-bottom: 0.5rem;
		font-size: 1.0625rem;
		font-weight: 600;
	}

	p {
		color: #6b7280;
		margin-bottom: 1.5rem;
		font-size: 0.9375rem;
	}

	small {
		display: block;
		margin-top: 0.75rem;
	}
}

.file-info-card {
	display: flex;
	align-items: center;
	gap: 1.25rem;
	padding: 1.25rem 1.5rem;
	background: #ecfdf5;
	border: 1px solid #a7f3d0;
	border-radius: 10px;
	margin-bottom: 1rem;

	.file-details {
		flex: 1;

		h4 {
			margin: 0 0 0.25rem 0;
			color: #065f46;
			font-size: 1rem;
			font-weight: 600;
		}

		p {
			margin: 0;
			color: #047857;
			font-size: 0.875rem;
		}
	}
}

.instructions-card {
	background: #fffbeb;
	border: 1px solid #fde68a;
	border-radius: 10px;
	padding: 1.5rem;

	.instruction-header {
		display: flex;
		align-items: center;
		color: #92400e;
		font-weight: 600;
		font-size: 1rem;
		margin-bottom: 1rem;

		i {
			font-size: 1.25rem;
			margin-right: 0.625rem;
		}
	}

	.instruction-list {
		list-style: none;
		padding: 0;
		margin: 0;

		li {
			padding: 0.625rem 0;
			padding-left: 1.75rem;
			position: relative;
			color: #78350f;
			font-size: 0.9375rem;
			line-height: 1.5;

			&:before {
				content: '✓';
				position: absolute;
				left: 0;
				color: #10b981;
				font-weight: bold;
				font-size: 1rem;
			}

			strong {
				color: #92400e;
				font-weight: 600;
			}
		}
	}
}

// Toast notifications personalizadas
:deep(.p-toast) {
	.p-toast-message {
		border-radius: 8px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	}

	.p-toast-message-success {
		background: #ecfdf5;
		border: 1px solid #a7f3d0;
		color: #065f46;

		.p-toast-message-icon {
			color: #10b981;
		}
	}

	.p-toast-message-error {
		background: #fef2f2;
		border: 1px solid #fecaca;
		color: #991b1b;

		.p-toast-message-icon {
			color: #ef4444;
		}
	}

	.p-toast-message-info {
		background: #eff6ff;
		border: 1px solid #bfdbfe;
		color: #1e40af;

		.p-toast-message-icon {
			color: #3b82f6;
		}
	}
}

// Inputs más limpios
:deep(.p-float-label) {
	margin-bottom: 0.25rem;

	input, .p-inputtext, .p-dropdown {
		border-color: #e5e7eb;
		
		&:hover {
			border-color: #d1d5db;
		}

		&:focus {
			border-color: #115780;
			box-shadow: 0 0 0 1px #0A354E;
		}
	}

	label {
		color: #6b7280;
		font-size: 0.9375rem;
	}
}

// Botones del footer
:deep(.p-dialog-footer) {
	background: #ffffff;
	border-top: 1px solid #e5e7eb;
	padding: 1.25rem 1.5rem;

	.p-button {
		font-weight: 500;
	}

	.p-button-primary {
		background: #667eea;
		border-color: #667eea;

		&:hover {
			background: #5568d3;
			border-color: #5568d3;
		}
	}
}

// Responsive
@media (max-width: 768px) {
	.section-header-detalles {
		flex-direction: column;
		gap: 0.75rem;
		align-items: flex-start;

		.p-button {
			width: 100%;
		}
	}

	.download-template-card {
		flex-direction: column;
		text-align: center;

		.template-info {
			text-align: center;
		}
	}

	.upload-area {
		padding: 2rem 1rem;
	}

	:deep(.detalles-table) {
		font-size: 0.8125rem;

		.p-datatable-thead > tr > th,
		.p-datatable-tbody > tr > td {
			padding: 0.75rem 0.5rem;
		}
	}

	.accordion-header-custom {
		flex-wrap: wrap;
		gap: 0.5rem;

		.text-sm {
			width: 100%;
			font-size: 0.8125rem;
		}
	}
}
.detalle-container-premium {
  padding: 0;
}

// Accordion Premium
:deep(.detalles-accordion-premium) {
  .p-accordion-header-link {
    padding: 0;
    border: none;
    background: transparent;
  }

  .p-accordion-tab {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
	margin: 0.5rem 0;
  }

  .p-accordion-content {
    padding: 0;
    border: none;
  }
}

.accordion-header-premium {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
//   background: #ffffff;
  width: 100%;

  .header-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, #0d496b 0%, #0A354E 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1.25rem;
    flex-shrink: 0;
  }

  .header-content {
    flex: 1;

    .detalle-title {
      font-size: 1.125rem;
      font-weight: 700;
      color: #1e293b;
      margin: 0 0 0.25rem 0;
    }

    .detalle-subtitle {
      font-size: 0.875rem;
      color: #64748b;
    }
  }

  .header-badge {
    flex-shrink: 0;
  }
}

// Tabs Premium
:deep(.detalle-tabs-premium) {
  .p-tabview-nav {
    background: #f8fafb;
    border: none;
    border-bottom: 2px solid #e2e8f0;
    padding: 0;
  }

  .p-tabview-nav-link {
    border: none;
    background: transparent;
    color: #64748b;
    font-weight: 600;
    font-size: 0.9375rem;
    padding: 1rem 1.5rem;

    &:hover {
      background: transparent;
      color: #1e293b;
    }
  }

  .p-highlight .p-tabview-nav-link {
    color: #1a5f7a;
    border-bottom: 3px solid #1a5f7a;
  }

  .p-tabview-panels {
    background: #ffffff;
  }
}

// Grid de Info Cards
.detalle-content-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.info-card-premium {
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  :deep(.p-card-title) {
    padding: 0.875rem 1rem;
    margin: 0;
    border-bottom: 1px solid #e2e8f0;
  }

  :deep(.p-card-content) {
    padding: 1rem;
  }

  &.producto :deep(.p-card-title) {
    background: #dbeafe;
  }

  &.peso :deep(.p-card-title) {
    background: #d1fae5;
  }

  &.unidades :deep(.p-card-title) {
    background: #fef3c7;
  }

  &.empaque :deep(.p-card-title) {
    background: #f3e8ff;
  }
}

.card-title-premium {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #1e293b;

  i {
    font-size: 1rem;
  }
}

.info-row {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.875rem;
  margin-bottom: 0.75rem;

  &:last-child {
    margin-bottom: 0;
  }

  .label {
    color: #64748b;
    font-weight: 500;
  }
}

.metric-display {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;

  .metric-value {
    font-size: 2rem;
    font-weight: 700;
    color: #1e293b;
    line-height: 1;
  }

  .metric-unit {
    font-size: 0.875rem;
    color: #64748b;
    font-weight: 500;
  }
}

// Ruta Visual
.route-visual-premium {
  display: flex;
  align-items: center;
  gap: 2rem;
  padding: 1.5rem;
  background: #f8fafb;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  margin-bottom: 1.5rem;
}

.route-point {
  flex: 1;
  display: flex;
  gap: 1rem;

  &.origin .point-marker {
    background: linear-gradient(135deg, #10b981, #059669);
  }

  &.sender .point-marker {
    background: linear-gradient(135deg, #10b981, #059669);
  }

  &.destination .point-marker {
    background: linear-gradient(135deg, #ef4444, #dc2626);
  }

  &.receiver .point-marker {
    background: linear-gradient(135deg, #ef4444, #dc2626);
  }
}

.point-marker {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.25rem;
  flex-shrink: 0;
}

.point-content {
  flex: 1;
}

.point-label {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #64748b;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}

.point-name {
  font-size: 1rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.5rem;
}

.point-extra {
	color: #64748b;
}

.point-address {
  font-size: 0.875rem;
  color: #64748b;
  line-height: 1.5;
}

.route-line {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  color: #94a3b8;
}

// Timeline Horizontal
.timeline-horizontal-premium {
  position: relative;
  width: 100%;
  padding: 2rem 1rem;
  overflow: hidden;
}

.timeline-track {
  display: flex;
  align-items: stretch;
  gap: 2rem;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 1rem 1rem 1rem;
  flex-direction: row;
  flex-wrap: nowrap;
  scroll-behavior: smooth;
  
  // Scrollbar personalizado
  &::-webkit-scrollbar {
    height: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
    
    &:hover {
      background: #94a3b8;
    }
  }
}


.timeline-event {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  min-width: 100px;
  max-width: 280px;
  flex-shrink: 0;

  &.llegada .event-circle {
    background: linear-gradient(135deg, #2e7eff, #4b84ff);
  }

  &.carga .event-circle {
    background: linear-gradient(135deg, rgb(255, 210, 132), rgb(242, 174, 96));
  }

  &.descarga .event-circle {
    background: linear-gradient(135deg, #2e7299, #155e89);
  }

  &.aceptado .event-circle, &.exitoso .event-circle {
    background: linear-gradient(135deg, #36c094, #36c094);
  }

  &.rechazado .event-circle {
    background: linear-gradient(135deg, #ef4444, #dc2626);
  }

  &.pendiente .event-circle {
    background: linear-gradient(135deg, #f59e0b, #d97706);
  }
}

.timeline-track::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 2px;
  background: #e5e7eb;
  transform: translateY(-50%);
  z-index: 0;
}

.event-circle {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.75rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-bottom: 1rem;
  z-index: 2;
}

.event-card-premium {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 1.25rem;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

.event-title {
  font-size: 0.875rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.event-date {
  font-size: 0.8125rem;
  color: #64748b;
  margin-bottom: 1rem;
  padding: 0.375rem 0.75rem;
  background: #f8fafb;
  border-radius: 6px;
}

.event-actions-premium {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  :deep(.p-button) {
    font-size: 0.75rem;
    padding: 0.5rem 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    font-weight: 600;
  }
}

.event-connector {
  position: absolute;
  top: 32px;
  left: 100%;
  width: 2rem;
  height: 2px;
  background: linear-gradient(90deg, #cbd5e1, #e2e8f0);
}

.timeline-controls {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  pointer-events: none;
  padding: 0;

  :deep(.p-button) {
    pointer-events: all;
    background: white;
    border: 2px solid #e2e8f0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    &:hover {
      background: #f8fafb;
      border-color: #1a5f7a;
    }
  }
}

// Map Toggle
.map-toggle-premium {
  display: flex;
  justify-content: center;
  margin: 1.5rem 0;
}

.map-container-premium {
  margin-top: 1.5rem;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.leaflet-map {
  height: 500px;
  width: 100%;
}

// Empty State
.empty-state-premium {
  text-align: center;
  padding: 4rem 2rem;

  img {
    max-width: 200px;
    margin-bottom: 1.5rem;
    opacity: 0.6;
  }

  h4 {
    font-size: 1.125rem;
    font-weight: 600;
    color: #64748b;
  }
}

.button-sewayblue{
    // background: RGB(117, 180, 225) !important;
	// background: linear-gradient(90deg, rgba(117, 180, 225, 1) 0%, rgba(212, 238, 255, 1) 50%) !important;
	// background: rgba(117, 180, 225, 1);
    background: #ffffff;
    color: #0A354E;
    // color: #0A354E;
}
.button-sewayblue:hover{
    background: #0c4f77;
    color: white;
}

.text-orange{
    background: #ffffff;
    color: #EB7D10;
}
.text-orange:hover{
    background: #EB7D10;
    color: white;
}

.indicators-row {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 1rem;
}


// Contenedor de indicadores - 7 elementos
// ── KPI Cards ────────────────────────────────────────────────────
.indicators-container-7 {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 0.875rem;
    width: 100%;
    margin-bottom: 1.5rem;
}

.kpi-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 1rem 1.1rem 0.875rem;
    border: 1.5px solid #e5e7eb;
    cursor: pointer;
    transition: transform 0.18s ease, box-shadow 0.18s ease;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    min-width: 0;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.09);
    }
}

.kpi-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.25rem;
}

.kpi-label {
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.6px;
    color: #6b7280;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.kpi-icon-wrap {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    i { font-size: 0.9rem; }
}

.kpi-value {
    font-size: 1.85rem;
    font-weight: 800;
    color: #111827;
    line-height: 1.1;
    display: flex;
    align-items: center;
    gap: 0.25rem;
}

.kpi-check-icon {
    font-size: 1rem !important;
    color: #10b981;
}

.kpi-footer {
    display: flex;
    align-items: center;
    margin-top: 0.1rem;
}

.kpi-badge {
    font-size: 0.68rem;
    font-weight: 600;
    padding: 0.2rem 0.6rem;
    border-radius: 20px;
    white-space: nowrap;
}

// ── Variantes por estado ─────────────────────────────────────────

// Total
.kpi-total         { border-color: #bfdbfe; }
.kpi-icon-total    { background: #dbeafe; i { color: #2563eb; } }
.kpi-badge-neutral { background: #dbeafe; color: #1d4ed8; }

// Pendiente
.kpi-pendiente         { border-color: #fde68a; }
.kpi-icon-pendiente    { background: #fef3c7; i { color: #d97706; } }
.kpi-badge-pendiente   { background: #fef3c7; color: #92400e; }

// Aceptado
.kpi-aceptado          { border-color: #6ee7b7; }
.kpi-icon-aceptado     { background: #d1fae5; i { color: #059669; } }
.kpi-badge-aceptado    { background: #d1fae5; color: #065f46; }

// Tránsito
.kpi-transito          { border-color: #93c5fd; }
.kpi-icon-transito     { background: #dbeafe; i { color: #2563eb; } }
.kpi-badge-transito    { background: #dbeafe; color: #1d4ed8; }

// Finalizado
.kpi-finalizado        { border-color: #6ee7b7; }
.kpi-icon-finalizado   { background: #d1fae5; i { color: #059669; } }
.kpi-badge-finalizado  { background: #d1fae5; color: #065f46; }

// Rechazado
.kpi-rechazado         { border-color: #fca5a5; }
.kpi-icon-rechazado    { background: #fee2e2; i { color: #dc2626; } }
.kpi-badge-rechazado   { background: #fee2e2; color: #991b1b; }

// Anulado
.kpi-anulado           { border-color: #d1d5db; }
.kpi-icon-anulado      { background: #f3f4f6; i { color: #6b7280; } }
.kpi-badge-anulado     { background: #f3f4f6; color: #374151; }

// ── Responsive ───────────────────────────────────────────────────
@media (max-width: 1200px) {
    .indicators-container-7 { grid-template-columns: repeat(4, 1fr); }
}
@media (max-width: 992px) {
    .indicators-container-7 { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 768px) {
    .indicators-container-7 { grid-template-columns: repeat(2, 1fr); }
    .kpi-value               { font-size: 1.5rem; }
}
@media (max-width: 480px) {
    .indicators-container-7 { grid-template-columns: 1fr; }
}

.indicator-wrapper {
    min-width: 0; // Permite que el grid funcione correctamente
}

// Ajustes de tamaño de indicadores para pantallas pequeñas
.indicator-card-modern {
    // Los estilos base que ya tienes se mantienen
    
    // Ajuste de padding para pantallas más pequeñas
    @media (max-width: 1600px) {
        padding: 1.25rem 1rem;
        
        .indicator-icon-modern {
            width: 50px;
            height: 50px;
            font-size: 1.6rem;
        }
        
        .indicator-value-modern {
            font-size: 2.2rem;
        }
        
        .indicator-title-modern {
            font-size: 0.8rem;
        }
    }
}

// Laptops grandes (1400px - 1600px)
@media (max-width: 1600px) {
    .indicators-container-7 {
        gap: 0.875rem;
    }
}

// Laptops medianos (1200px - 1400px)
@media (max-width: 1400px) {
    .indicators-container-7 {
        gap: 0.75rem;
    }
    
    .indicator-card-modern {
        padding: 1rem 0.75rem;
        
        .indicator-icon-modern {
            width: 45px;
            height: 45px;
            font-size: 1.4rem;
            margin-bottom: 0.75rem;
        }
        
        .indicator-value-modern {
            font-size: 2rem;
        }
        
        .indicator-title-modern {
            font-size: 0.75rem;
        }
    }
}

// Laptops pequeños y tablets horizontales (992px - 1200px)
// Aquí cambiamos a 4 columnas
@media (max-width: 1200px) {
    .indicators-container-7 {
        grid-template-columns: repeat(4, 1fr);
        gap: 1rem;
    }
}

// Tablets (768px - 992px) - 3 columnas
@media (max-width: 992px) {
    .indicators-container-7 {
        grid-template-columns: repeat(3, 1fr);
        gap: 1rem;
    }
    
    .indicator-card-modern {
        padding: 1.25rem;
        
        .indicator-icon-modern {
            width: 50px;
            height: 50px;
            font-size: 1.5rem;
        }
        
        .indicator-value-modern {
            font-size: 2.2rem;
        }
    }
}

// Móviles grandes (576px - 768px) - 2 columnas
@media (max-width: 768px) {
    .indicators-container-7 {
        grid-template-columns: repeat(2, 1fr);
        gap: 0.875rem;
    }
}

// Móviles pequeños (menos de 576px) - 1 columna
@media (max-width: 576px) {
    .indicators-container-7 {
        grid-template-columns: 1fr;
        gap: 0.75rem;
    }
    
    .indicator-card-modern {
        padding: 1rem;
    }
}

// Responsive
@media (max-width: 768px) {
  .route-visual-premium {
    flex-direction: column;
    gap: 1.5rem;
  }

  .route-line {
    transform: rotate(90deg);
  }

  .detalle-content-grid {
    grid-template-columns: 1fr;
  }

  .timeline-event {
    min-width: 240px;
  }

  .event-circle {
    width: 56px;
    height: 56px;
    font-size: 1.5rem;
  }
}

// ── Actores ───────────────────────────────────────────────────────
.actores-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1.25rem;
    padding: 1rem 0;
}

.actor-card {
    background: #ffffff;
    border-radius: 14px;
    padding: 1.5rem;
    border: 1px solid #e2e8f0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: all 0.25s ease;
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
    }

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    }

    &.vehiculo::before   { background: linear-gradient(90deg, #0A354E, #1a6b8a); }
    &.conductor::before  { background: linear-gradient(90deg, #10b981, #059669); }
    &.propietario::before { background: linear-gradient(90deg, #f59e0b, #d97706); }
    &.representante::before { background: linear-gradient(90deg, #8b5cf6, #7c3aed); }
}

.actor-card-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1.25rem;
}

.actor-icon-wrapper {
    width: 52px;
    height: 52px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    i { font-size: 1.4rem; color: white; }

    &.vehiculo-icon     { background: linear-gradient(135deg, #0A354E, #1a6b8a); }
    &.conductor-icon    { background: linear-gradient(135deg, #10b981, #059669); }
    &.propietario-icon  { background: linear-gradient(135deg, #f59e0b, #d97706); }
    &.representante-icon { background: linear-gradient(135deg, #8b5cf6, #7c3aed); }
}

.actor-tipo {
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: #94a3b8;
    margin-bottom: 0.25rem;
}

.actor-nombre {
    font-size: 1rem;
    font-weight: 700;
    color: #1e293b;
    line-height: 1.3;
}

.actor-info-grid {
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
    border-top: 1px solid #f1f5f9;
    padding-top: 1rem;
}

.actor-info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
}

.actor-info-label {
    font-size: 0.75rem;
    color: #94a3b8;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    white-space: nowrap;
}

.actor-info-value {
    font-size: 0.875rem;
    color: #334155;
    font-weight: 600;
    text-align: right;
    word-break: break-word;
}

.actor-badge-row {
    border-top: 1px solid #f1f5f9;
    padding-top: 1rem;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.actor-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.375rem 0.875rem;
    border-radius: 20px;
    font-size: 0.8125rem;
    font-weight: 600;

    &.placa {
        background: #e0f2fe;
        color: #0369a1;
        border: 1px solid #bae6fd;
    }
}

@media (max-width: 768px) {
    .actores-container {
        grid-template-columns: 1fr;
    }
}

.filtros-activos-bar {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.875rem;
    background: #eef2ff;
    border: 1px solid #c7d2fe;
    border-radius: 8px;
    flex-wrap: wrap;
    margin-right: 0.75rem;
}

.filtros-label {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    font-size: 0.75rem;
    font-weight: 700;
    color: #0A354E;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;

    i { font-size: 0.8rem; color: #0A354E; }
}

.filtro-chip {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    background: #ffffff;
    border: 1px solid #a5b4fc;
    color: #1e293b;
    padding: 0.25rem 0.625rem;
    border-radius: 20px;
    font-size: 0.8125rem;
    font-weight: 600;

    i {
        font-size: 0.7rem;
        color: #64748b;
        cursor: pointer;
        transition: color 0.2s;

        &:hover { color: #ef4444; }
    }
}

.filtro-limpiar-todo {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background: #fee2e2;
    border: 1px solid #fecaca;
    border-radius: 50%;
    cursor: pointer;
    margin-left: auto;
    transition: all 0.2s;

    i { font-size: 0.7rem; color: #ef4444; }

    &:hover {
        background: #ef4444;
        i { color: white; }
    }
}

.ver-todos-eventos-btn {
    display: flex;
    justify-content: center;
    margin-top: 1.5rem;
    padding-top: 1rem;
    border-top: 1px solid #e2e8f0;
}

.mapa-leyenda {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    padding: 0.875rem 1rem;
    background: #f8fafb;
    border-top: 1px solid #e2e8f0;
    border-radius: 0 0 8px 8px;
    margin-top: 0.5rem;
}

.leyenda-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    color: #475569;
    font-weight: 500;
}

.leyenda-dot {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 0.7rem;
    font-weight: 700;
    border: 2px solid white;
    box-shadow: 0 1px 4px rgba(0,0,0,0.2);
    flex-shrink: 0;
}

.modal-anular .p-dialog-content {
    padding-top: 1rem;
}

.modal-anular .p-dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
}
// ══ VIAJES SINCRONIZADOS — diseño unificado ══════════════════════

$navy:#0A354E; $orange:#EB7D10; $white:#fff;
$g200:#e8eaed; $g500:#6b7280; $g700:#374151; $r:16px; $bg:#f7f7f7;

/* ── Topbar ── */
.sv-topbar { display:flex; justify-content:space-between; align-items:center; margin-bottom:1rem; flex-wrap:wrap; gap:.75rem; background:$white; border:1px solid $g200; border-radius:$r; padding:.875rem 1.25rem; }
.sv-topbar-left  { display:flex; align-items:center; gap:.75rem; flex:1; }
.sv-topbar-right { display:flex; align-items:center; gap:.65rem; flex-wrap:wrap; }
.sv-title  { font-size:1.25rem; font-weight:700; color:$g700; margin:0 0 .15rem; }
.sv-sub    { font-size:.78rem; color:$g500; margin:0; }

/* Botón volver */
.sv-btn-back { display:inline-flex; align-items:center; justify-content:center; width:34px; height:34px; background:$white; border:1px solid $g200; border-radius:8px; cursor:pointer; color:$g700; transition:all .15s; flex-shrink:0; &:hover{border-color:$navy;color:$navy;} }

/* ── Buttons ── */
.sv-btn-primary { display:inline-flex; align-items:center; gap:.35rem; background:$navy; color:#fff; border:none; border-radius:8px; padding:.45rem 1rem; font-size:.82rem; font-weight:600; cursor:pointer; transition:background .15s; i{font-size:13px;} &:hover{background:#0c4f77;} &:disabled{opacity:.6;cursor:not-allowed;} }
.sv-btn-outline  { display:inline-flex; align-items:center; gap:.35rem; background:$white; color:$g700; border:1px solid $g200; border-radius:8px; padding:.45rem .9rem; font-size:.82rem; font-weight:600; cursor:pointer; transition:all .15s; i{font-size:13px;} &:hover{border-color:$navy;color:$navy;} }
.sv-btn-danger   { display:inline-flex; align-items:center; gap:.35rem; background:#dc2626; color:#fff; border:none; border-radius:8px; padding:.45rem 1rem; font-size:.82rem; font-weight:600; cursor:pointer; &:hover{background:#b91c1c;} &:disabled{opacity:.6;cursor:not-allowed;} }
.sv-btn-icon     { display:inline-flex; align-items:center; justify-content:center; width:30px; height:30px; background:$white; border:1px solid $g200; border-radius:6px; cursor:pointer; color:$g700; font-size:.8rem; transition:all .15s; &:hover{border-color:$navy;color:$navy;} }
.sv-btn-icon--warn { &:hover{border-color:$orange;color:$orange;} }

/* Acciones en fila tabla */
.sv-row-actions { display:flex; gap:.35rem; }

/* ── Tabla outer ── */
.sv-tabla-outer { background:$white; border:1px solid $g200; border-radius:$r; overflow:hidden; padding:.5rem 0 0; }

/* ── Filtros activos bar ── */
.sv-filtros-activos { display:flex; align-items:center; gap:.4rem; flex-wrap:wrap; padding:.4rem .75rem; background:#eef2ff; border:1px solid #c7d2fe; border-radius:8px; }
.sv-filtros-label   { display:flex; align-items:center; gap:.3rem; font-size:.72rem; font-weight:700; color:$navy; text-transform:uppercase; letter-spacing:.5px; white-space:nowrap; i{font-size:.75rem;} }
.sv-chip { display:inline-flex; align-items:center; gap:.3rem; background:$white; border:1px solid #a5b4fc; color:$g700; padding:.2rem .6rem; border-radius:20px; font-size:.78rem; font-weight:600; i{font-size:.65rem;color:$g500;cursor:pointer; &:hover{color:#ef4444;}} }
.sv-chip-clear { width:22px; height:22px; background:#fee2e2; border:1px solid #fecaca; border-radius:50%; cursor:pointer; display:inline-flex; align-items:center; justify-content:center; margin-left:.25rem; i{font-size:.65rem;color:#ef4444;} &:hover{background:#ef4444; i{color:$white;}} }

/* ── Panel filtros overlay ── */
.sv-filtros-panel { padding:.25rem; }
.sv-filtros-title  { display:flex; align-items:center; gap:.5rem; font-size:.9rem; font-weight:700; color:$navy; padding-bottom:.75rem; border-bottom:1px solid $g200; margin-bottom:.875rem; i{font-size:14px;} }
.sv-filtros-grid   { display:grid; grid-template-columns:repeat(2,1fr); gap:.75rem; margin-bottom:1rem; }
.sv-filtros-field  { display:flex; flex-direction:column; gap:.3rem; label{font-size:.72rem;font-weight:700;color:$g500;text-transform:uppercase;letter-spacing:.5px;} }
.sv-filtros-field--full { grid-column:1/-1; }
.sv-filtros-actions { display:flex; justify-content:flex-end; gap:.65rem; padding-top:.75rem; border-top:1px solid $g200; }

/* ── Modal anular ── */
.sv-dialog {
  :deep(.p-dialog-header){ font-weight:700; font-size:1rem; border-bottom:1px solid $g200; }
  :deep(.p-dialog-content){ padding:1.5rem; }
  :deep(.p-dialog-footer){ border-top:1px solid $g200; padding:1rem 1.5rem; display:flex; justify-content:flex-end; gap:.65rem; }
}
.sv-modal-body  { display:flex; flex-direction:column; gap:1rem; }
.sv-confirm-body { display:flex; align-items:flex-start; gap:1rem; padding:.25rem; }
.sv-confirm-icon { width:48px; height:48px; border-radius:12px; display:flex; align-items:center; justify-content:center; flex-shrink:0; i{font-size:1.3rem;} }
.sv-confirm-icon--danger { background:#fef2f2; i{color:#dc2626;} }
.sv-confirm-q   { font-size:.9rem; font-weight:600; color:$g700; margin:0 0 .35rem; }
.sv-confirm-sub { font-size:.82rem; color:$g500; margin:0; line-height:1.4; }
.sv-form-field  { display:flex; flex-direction:column; gap:.3rem; label{font-size:.72rem;font-weight:700;color:$g500;text-transform:uppercase;letter-spacing:.5px;} }
.sv-error       { font-size:.72rem; color:#dc2626; }
</style>